<template>
  <div>
    <DxDataGrid ref="dataGrid" :allowColumnReordering="true" :data-source="{
      store: dsSales,
      filter: gridFilter
    }" :allowColumnResizing="true" key-expr="ID" :columnAutoWidth="false" :columnResizingMode="'nextColumn'"
      :remote-operations="true" :show-borders="true" :syncLookupFilterValues="false" :filter-sync-enabled="true"
      :show-row-lines="true" :show-column-lines="false" :allowMerging="'Cells'" height="100%"
      class="grid theme-dependent" @exporting="onExporting" @row-click="onRowClick">
      <DxSelection mode="single" />
      <DxScrolling :mode="'virtual'" />
      <DxColumnChooser :enabled="true" :allow-search="true" title="Selector coloane" />
      <DxPaging :page-size="20" />
      <DxSorting mode="multiple" />
      <DxHeaderFilter :visible="false" />
      <DxFilterRow :visible="true" />
      <DxLoadPanel :show-pane="false" />

      <DxExport :enabled="true" :allow-export-selected-data="true" :formats="['xlsx', 'pdf']" />
      <DxGridToolbar>
        <DxGridToolbarItem location="before">
          <template #default>
            <button class="continue-application" @click="goToOpportunities">
              <div>
                <div class="folder">
                  <div class="top">
                    <svg viewBox="0 0 24 27">
                      <path d="M0 0h24v27H0z"></path>
                    </svg>
                  </div>
                  <div class="paper"></div>
                </div>
                <div class="pencil"></div>
              </div>
              Vezi pagina de oportunități
            </button>
          </template>
        </DxGridToolbarItem>
        <DxGridToolbarItem location="after" locate-in-menu="auto">
          <div>
            <dx-button icon="plus" type="success" @click="onAddClick" hint="Adauga Oportunitate" />
          </div>
        </DxGridToolbarItem>
        <DxGridToolbarItem location="after" locate-in-menu="auto">
          <div>
            <DxButton icon="refresh" @click="onRefreshClick" hint="Reimprospateaza" />
          </div>
        </DxGridToolbarItem>
        <DxGridToolbarItem location="after" locate-in-menu="auto">
          <div>
            <div class="separator"></div>
          </div>
        </DxGridToolbarItem>
        <DxGridToolbarItem name="exportButton" hint="Exporta" />
        <DxGridToolbarItem location="after" locate-in-menu="auto">
          <div>
            <div class="separator"></div>
          </div>
        </DxGridToolbarItem>
        <DxGridToolbarItem name="columnChooserButton" locate-in-menu="auto" hint="Alege Coloanele" />
        <DxGridToolbarItem name="searchPanel" locate-in-menu="auto" />
      </DxGridToolbar>
      <DxTexts group-continued-message="Continuat de pe pagina anterioara"
        group-continues-message="Continuat pe pagina urmatoare" />
      <!-- <DxEditing :allowUpdating="true" :allowDeleting="true" mode="popup">
        <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="800" :height="750">
          <DxToolbarItem :template="customTitleTemplate" />
          <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="successButtonOptions" />
          <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="dangerButtonOptions" />
        </DxPopup>

        <DxFormGrid :col-count="1" label-alignment="center">
         
          <DxFormItemGrid item-type="group" caption="Info. General" :col-span="1" :col-count="1"
            css-class="form-section-simple form-section-card">
            <DxFormItemGrid data-field="Titlu" :label="{ text: 'Denumire oportunitate' }" />

            <DxFormItemGrid data-field="StatusID" editor-type="dxSelectBox" :editor-options="{
              dataSource: dsStatus,
              valueExpr: 'ID',
              displayExpr: 'Nume',
              searchEnabled: true,
              placeholder: 'Nou',
              showClearButton: true,
              readOnly: true
            }" />
            <DxFormItemGrid dataField="Data" :editorType="'dxDateBox'"
              :editor-options="{ displayFormat: 'dd/MM/yyyy', dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ' }"
              :label="{ text: 'Data Creare' }" />
            <DxFormItemGrid dataField="Owner" :editor-options="{ readOnly: true }" :label="{ text: 'Responsabil' }" />
          </DxFormItemGrid>

         
          <DxFormItemGrid item-type="group" caption="Relații" :col-span="1" :col-count="1"
            css-class="form-section-simple form-section-card">
          
            <DxFormItemGrid dataField="SursaID" :label="{ text: 'Sursă Lead' }" editorType="dxSelectBox"
              :editor-options="{
                dataSource: dsSalesSources,
                valueExpr: 'ID',
                displayExpr: 'Nume',
                searchEnabled: true,
                placeholder: 'Selectează sursa',
                showClearButton: true
              }" />

            <DxFormItemGrid dataField="ProiectID" :label="{ text: 'Proiect' }" editorType="dxSelectBox" :editor-options="{
              dataSource: dsProiecte,
              valueExpr: 'Id',
              displayExpr: 'Cod',
              searchEnabled: true,
              placeholder: 'Selectează proiect',
              showClearButton: true
            }" />
          </DxFormItemGrid>

         
          <DxFormItemGrid item-type="group" caption="Info.Financiar" :col-span="1" :col-count="1"
            css-class="form-section-simple form-section-card">
            <DxFormItemGrid dataField="ValutaID" :label="{ text: 'Valută' }" editorType="dxSelectBox" :editor-options="{
              dataSource: dsValuta,
              valueExpr: 'Id',
              displayExpr: 'Nume',
              searchEnabled: true,
              placeholder: 'Selectează valuta',
              showClearButton: true
            }" />
            <DxFormItemGrid dataField="BugetEstimat" editorType="dxNumberBox"
              :editor-options="{ showSpinButtons: true, format: '#0.00' }" />
            <DxFormItemGrid dataField="VenitEstimat" :label="{ text: 'Venit Estimat' }" editorType="dxNumberBox"
              :editor-options="{ showSpinButtons: true, format: '#0.00' }" />
            
            <DxFormItemGrid dataField="CostEstimat" :label="{ text: 'Cost Estimat' }" editorType="dxNumberBox"
              :editor-options="{ showSpinButtons: true, format: '#0.00' }" />
           
          </DxFormItemGrid>

        
          <DxFormItemGrid item-type="group" caption="Achiziție" :col-span="1" :col-count="1"
            css-class="form-section-simple form-section-card">
            <DxFormItemGrid dataField="IntervalCumparare" :label="{ text: 'Interval Cumpărare' }"
              editorType="dxSelectBox" :editor-options="{
                dataSource: intervalList,
                valueExpr: 'name',
                displayExpr: 'name',
                searchEnabled: true,
                placeholder: 'Selectează interval',
                showClearButton: true
              }" />
            <DxFormItemGrid dataField="DataInchidereEstimat" :label="{ text: 'Data Inchidere Estimat' }"
              :editorType="'dxDateBox'"
              :editor-options="{ displayFormat: 'dd/MM/yyyy', dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ' }" />
            <DxFormItemGrid dataField="Cerere" />
            <DxFormItemGrid data-field="Oferta" />
            <DxFormItemGrid dataField="IndustrieID" :label="{ text: 'Industrie' }" editorType="dxSelectBox"
              :editor-options="{
                dataSource: dsIndustrii,
                valueExpr: 'ID',
                displayExpr: 'Nume',
                searchEnabled: true,
                placeholder: 'Selectează industrie',
                showClearButton: true
              }" />
            <DxFormItemGrid dataField="CampanieID" :label="{ text: 'Campanie' }" editorType="dxSelectBox"
              :editor-options="{
                dataSource: dsCampaniiMarketing,
                valueExpr: 'ID',
                displayExpr: 'Denumire',
                searchEnabled: true,
                placeholder: 'Selectează campanie',
                showClearButton: true
              }" />
            <DxFormItemGrid dataField="Note" editorType="dxTextArea" :editor-options="{ height: 100 }" />
          </DxFormItemGrid>
        </DxFormGrid>

      </DxEditing> -->

      <DxStateStoring :enabled="true" :filterValue="false" :savingTimeout="100"
        storage-key="gridCardOportunitatiState" />
      <DxColumn data-field="Titlu" />
      <DxColumn data-field="Contact.Nume" :visible="false" caption="Nume Contact" />
      <DxColumn data-field="Account.Nume" :visible="false" caption="Partener" />
      <DxColumn data-field="AccountID" :visible="false" :show-in-column-chooser="false"
        :edit-cell-template="'accountCellEditor'" />
      <template #accountCellEditor="{ data }">
        <DxDropDownBox :data-source="dsParteneri" value-expr="ID" :display-expr="displayCompanie" :value="data.value"
          v-model:opened="isAccountDdbOpen" :show-clear-button="true">
          <template #content>
            <DxDataGrid :data-source="dsParteneri" key-expr="ID" :columns="['Nume']" height="100%" @selection-changed="e => {
              const id = e.selectedRowKeys?.[0] ?? null;
              data.setValue(id);
              isAccountDdbOpen = false;
            }">
              <DxSelection mode="single" />
            </DxDataGrid>
          </template>
        </DxDropDownBox>
      </template>
      <DxColumn data-field="Sursa" :visible="false" caption="Sursă" />
      <DxColumn data-field="Proiect.Nume" :visible="false" caption="Proiect" />
      <DxColumn data-field="ProiectID" :visible="false" :show-in-column-chooser="false"
        :edit-cell-template="'proiectCellEditor'" />
      <template #proiectCellEditor="{ data }">
        <DxSelectBox :data-source="dsProiecte" :value="data.value" value-expr="Id" display-expr="Cod"
          :search-enabled="true" @value-changed="(e) => data.setValue(e.value)" />
      </template>
      <DxColumn data-field="IntervalCumparare" :visible="false" />
      <DxColumn data-field="BugetEstimat" :visible="false" caption="Buget Estimat" />
      <DxColumn data-field="Note" :visible="false" caption="Note" />
      <DxColumn data-field="Cerere" :visible="false" caption="Cerere" />
      <DxColumn data-field="Oferta" :visible="false" caption="Ofertă" />
      <DxColumn data-field="DataInchidereEstimat" :visible="false" caption="Închidere Estimată" />
      <DxColumn data-field="VenitEstimat" :visible="false" caption="Venit Estimat" />

      <DxColumn data-field="Owner" caption="Responsabil" />
      <DxColumn data-field="VenitRealizat" :visible="false" caption="Venit Realizat" />
      <DxColumn data-field="DataInchis" :visible="false" caption="Data Închidere" />
      <DxColumn data-field="UltimulStatus" :visible="false" caption="Ultimul Status" />
      <DxColumn data-field="Industrie.Nume" :visible="false" caption="Industrie" />
      <DxColumn data-field="IndustrieID" :visible="false" :show-in-column-chooser="false"
        :edit-cell-template="'industrieCellEditor'" />
      <template #industrieCellEditor="{ data }">
        <DxDropDownBox :data-source="dsIndustrii" value-expr="ID" display-expr="Nume" :value="data.value"
          v-model:opened="isIndustrieDdbOpen" :show-clear-button="true">
          <template #content>
            <DxDataGrid :data-source="dsIndustrii" key-expr="ID" :columns="['Nume']" height="100%" @selection-changed="e => {
              const id = e.selectedRowKeys?.[0] ?? null;
              data.setValue(id);
              isIndustrieDdbOpen = false;
            }">
              <DxSelection mode="single" />
            </DxDataGrid>
          </template>
        </DxDropDownBox>
      </template>

      <DxColumn data-field="Campanie.Nume" :visible="false" caption="Campanie" />
      <DxColumn data-field="CampanieID" :visible="false" :show-in-column-chooser="false"
        :edit-cell-template="'campanieCellEditor'" />
      <template #campanieCellEditor="{ data }">
        <DxDropDownBox :data-source="dsCampaniiMarketing" value-expr="ID" display-expr="Denumire" :value="data.value"
          v-model:opened="isCampanieDdbOpen" :show-clear-button="true">
          <template #content>
            <DxDataGrid :data-source="dsCampaniiMarketing" key-expr="ID" :columns="['Denumire']" height="100%"
              @selection-changed="e => {
                const id = e.selectedRowKeys?.[0] ?? null;
                data.setValue(id);
                isCampanieDdbOpen = false;
              }">
              <DxSelection mode="single" />
            </DxDataGrid>
          </template>
        </DxDropDownBox>
      </template>
      <DxColumn data-field="CostEstimat" :visible="false" caption="Cost Estimat" />
      <DxColumn data-field="CostEfectiv" :visible="false" caption="Cost Efectiv" />
      <DxColumn data-field="ListaProduse" :visible="false" caption="Produse" />
      <DxColumn data-field="Cod" :visible="false" />
      <DxColumn data-field="Valuta.Nume" :visible="false" caption="Valuta" />
      <DxColumn data-field="ValutaID" :visible="false" :show-in-column-chooser="false"
        :edit-cell-template="'valutaCellEditor'" />
      <template #valutaCellEditor="{ data }">
        <DxSelectBox :data-source="dsValuta" :value="data.value" value-expr="Id" display-expr="Nume"
          :search-enabled="true" @value-changed="(e) => data.setValue(e.value)" />
      </template>
      <DxColumn data-field="Curs" :visible="false" caption="Curs" />
      <DxColumn data-field="Sursa.Nume" :visible="false" caption="Sursa" />
      <DxColumn data-field="SursaID" :visible="false" :show-in-column-chooser="false"
        :edit-cell-template="'sursaCellEditor'" />
      <template #sursaCellEditor="{ data }">
        <DxSelectBox :data-source="dsSalesSources" :value="data.value" value-expr="ID" display-expr="Nume"
          :search-enabled="true" @value-changed="(e) => data.setValue(e.value)" />
      </template>
      <DxColumn data-field="Data" :visible="false" />
      <DxColumn data-field="Status.Nume" caption="Status" />
      <DxColumn data-field="StatusID" :visible="false" :show-in-column-chooser="false"
        :edit-cell-template="'statusCellEditor'" />
      <template #statusCellEditor="{ data }">
        <DxSelectBox :data-source="dsStatus" :value="data.value" value-expr="ID" display-expr="Nume"
          :search-enabled="true" @value-changed="(e) => data.setValue(e.value)" />
      </template>
      <DxColumn type="buttons" :visible-index="9999" :allow-reordering="false" :allow-resizing="false" width="90"
        :buttons="[
          {
            hint: 'Vezi detalii',
            icon: 'info',
            onClick: onViewDetails
          },
          'edit',
          {
            name: 'delete',
            visible: (e) => {
              return isOwner(e.row.data.Owner);
            }
          }
        ]" />


    </DxDataGrid>
    <DxPopupAdd v-model:visible="isOpportunityDetailsVisible" :drag-enabled="false" :hide-on-outside-click="true"
      :show-close-button="true" :width="750" :height="700">
      <template #title>
        <div class="popup-header popup-header--details">
          <div class="popup-header-main">
            <span class="popup-header-icon dx-icon-info"></span>
            <div class="popup-header-texts">
              <div class="popup-header-title">{{ selectedOpportunity.Titlu || 'Detalii Oportunitate' }}</div>
              <div class="popup-header-subtitle">Document de analiză comercială</div>
            </div>
          </div>
          <div class="popup-header-meta">
            <span :class="['status-chip', 'status-chip--' + getStatusClass(selectedOpportunity.Status)]">
              {{ selectedOpportunity.Status || 'Status necunoscut' }}
            </span>
          </div>
        </div>
      </template>

      <DxScrollView width="100%" height="100%" class="details-scroll-view">
        <div class="details-container">
          <!-- Quick Stats Row -->
          <div class="stats-grid">
            <div class="stat-card stat-card--revenue">
              <div class="stat-icon dx-icon-money"></div>
              <div class="stat-content">
                <div class="stat-label">Venit Estimat</div>
                <div class="stat-value">{{ formatCurrency(selectedOpportunity.VenitEstimat, selectedOpportunity.Valuta)
                }}
                </div>
              </div>
            </div>

            <div class="stat-card stat-card--owner">
              <div class="stat-icon dx-icon-user"></div>
              <div class="stat-content">
                <div class="stat-label">Responsabil</div>
                <div class="stat-value">{{ selectedOpportunity.Owner || '-' }}</div>
              </div>
            </div>
          </div>

          <!-- Main Info Grid -->
          <div class="info-sections-grid">
            <!-- General Column -->
            <div class="info-column">
              <div class="info-section-card">
                <div class="section-header">
                  <span class="dx-icon-group section-icon"></span>
                  <span>Informații Generale</span>
                </div>
                <div class="info-list">

                  <div class="info-item">
                    <label>Contact Principal</label>
                    <div class="value">{{ selectedOpportunity.Contact || '-' }}</div>
                  </div>
                  <div class="info-item">
                    <label>Sursa</label>
                    <div class="value">{{ selectedOpportunity.Sursa || '-' }}</div>
                  </div>
                  <div class="info-item">
                    <label>Industrie</label>
                    <div class="value">{{ selectedOpportunity.Industrie || '-' }}</div>
                  </div>
                </div>
              </div>

              <div class="info-section-card">
                <div class="section-header">
                  <span class="dx-icon-event section-icon"></span>
                  <span>Planificare</span>
                </div>
                <div class="info-list">
                  <div class="info-item">
                    <label>Data Creării</label>
                    <div class="value">{{ formatDate(selectedOpportunity.Data) }}</div>
                  </div>
                  <div class="info-item">
                    <label>Închidere Estimată</label>
                    <div class="value highlight">{{ formatDate(selectedOpportunity.DataInchidereEstimat) }}</div>
                  </div>
                  <div class="info-item">
                    <label>Interval Cumpărare</label>
                    <div class="value">{{ selectedOpportunity.IntervalCumparare || '-' }}</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Business Column -->
            <div class="info-column">
              <div class="info-section-card">
                <div class="section-header">
                  <span class="dx-icon-folder section-icon"></span>
                  <span>Detalii Business</span>
                </div>
                <div class="info-list">
                  <div class="info-item">
                    <label>Cerere / Nevoie</label>
                    <div class="value multiline">{{ selectedOpportunity.Cerere || '-' }}</div>
                  </div>
                  <div class="info-item">
                    <label>Oferta Propsă</label>
                    <div class="value multiline">{{ selectedOpportunity.Oferta || '-' }}</div>
                  </div>
                  <div class="info-item">
                    <label>Explicație / Note</label>
                    <div class="value multiline">{{ selectedOpportunity.Note || '-' }}</div>
                  </div>
                </div>
              </div>

              <div class="info-section-card">
                <div class="section-header">
                  <span class="dx-icon-box section-icon"></span>
                  <span>Analiză Financiară</span>
                </div>
                <div class="info-list">
                  <div class="info-item">
                    <label>Buget Estimat</label>
                    <div class="value">{{ formatCurrency(selectedOpportunity.BugetEstimat, selectedOpportunity.Valuta)
                    }}
                    </div>
                  </div>
                  <div class="info-item">
                    <label>Venit Realizat</label>
                    <div class="value success">{{ formatCurrency(selectedOpportunity.VenitRealizat,
                      selectedOpportunity.Valuta) }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Bottom Meta Section -->
          <div class="system-meta-card">
            <div class="meta-row">
              <div class="meta-item">
                <span class="dx-icon-edit meta-icon"></span>
                <span>Creat de <strong>{{ selectedOpportunity.UserCreat || 'Sistem' }}</strong> la {{
                  formatDate(selectedOpportunity.DataCreat, true) }}</span>
              </div>
              <div class="meta-separator"></div>
              <div class="meta-item">
                <span class="dx-icon-refresh meta-icon"></span>
                <span>Ultima modificare: {{ formatDate(selectedOpportunity.DataModificat, true) }}</span>
              </div>
            </div>
          </div>
        </div>
      </DxScrollView>
    </DxPopupAdd>
    <DxPopupAdd :visible.sync="isModalVisible" :showTitle="true" :height="615" :width="1350">
      <template #title>
        <div class="popup-header">
          <div class="popup-header-main">
            <span class="popup-header-icon dx-icon-add"></span>
            <div class="popup-header-texts">
              <div class="popup-header-title">Adăugare oportunitate</div>
              <div class="popup-header-subtitle">
                Completează informațiile în pașii de mai jos
              </div>
            </div>
          </div>
          <div class="popup-header-meta">
            <span class="status-chip status-chip--draft">
              Nouă
            </span>
          </div>
        </div>
      </template>

      <div ref="popupBody" class="popup-body-simple popup-body-modern">

        <div class="form-content form-content-modern">
          <DxForm :formData="formData" :col-count="2" :col-span="2">
            <!-- TAB 1 -->
            <DxFormItem item-type="group" :caption="tabs[0]" :col-count="2"
              css-class="form-section-simple form-section-card">
              <DxFormItem dataField="Titlu" css-class="field-full-width" :col-span="2">
                <DxLabel text="Denumire Oportunitate" />
                <DxRequiredRule message="Denumirea este obligatorie" />
              </DxFormItem>


              <DxFormItem :label="{ text: 'Status' }" :col-span="1">

                <DxDropDownBox v-model:value="sStatus" :data-source="dsStatus" display-expr="Nume" value-expr="ID"
                  :show-clear-button="true" placeholder="Nou" content-template="gridContent" :read-only="true">
                  <template #gridContent>
                    <div class="dropdown-grid-container" style="height: 300px;">
                      <DxDataGrid :data-source="dsStatus" :hover-state-enabled="true" :height="280"
                        :remote-operations="true" @row-click="onStatusRowClick">
                        <DxPaging :enabled="true" :page-size="5" />
                        <DxFilterRow :visible="true" />
                        <DxScrolling mode="virtual" />
                        <DxSorting mode="single" />

                        <DxColumn data-field="NrOrd" :visible="false" sort-order="asc" :sort-index="0" />

                        <DxColumn data-field="Nume" caption="Status" />
                        <DxColumn data-field="Pondere" caption="Pondere (%)" width="120" />
                      </DxDataGrid>


                    </div>
                  </template>
                </DxDropDownBox>
              </DxFormItem>



              <DxFormItem dataField="Owner" :editor-options="{ readOnly: true }" :col-span="1">
                <DxLabel text="Responsabil" />
              </DxFormItem>


              <DxFormItem :label="{ text: 'Partener' }" :col-span="1">
                <DxRequiredRule message="Partenerul este obligatoriu" />
                <DxDropDownBox v-model:value="sPartener" v-model:opened="isParteneriGridBoxOpened"
                  :data-source="dsParteneri" display-expr="Nume" value-expr="ID" :show-clear-button="true"
                  placeholder="Selectează partener" content-template="gridContent" :read-only="true"
                  :drop-down-options="{ width: 500, height: 400 }">
                  <template #gridContent>
                    <div class="dropdown-grid-container" style="height: 300px;">
                      <DxDataGrid :data-source="dsParteneri" :columns="['Nume']" :hover-state-enabled="true"
                        :height="280" :remote-operations="true" @row-click="onPartenerRowClick">
                        <DxScrolling mode="virtual" />
                        <DxFilterRow :visible="true" />
                        <DxPaging :enabled="true" :page-size="5" />
                        <DxSearchPanel :visible="true" placeholder="Caută..." />

                        <DxGridToolbar>
                          <DxGridToolbarItem location="after">
                            <DxButton icon="plus" type="success" height="25px" width="25px" @click="onAddNewPartener" />
                          </DxGridToolbarItem>
                          <DxGridToolbarItem name="searchPanel" />
                        </DxGridToolbar>
                      </DxDataGrid>
                    </div>
                  </template>
                </DxDropDownBox>
              </DxFormItem>

              <DxFormItem :label="{ text: 'Persoană de Contact' }">

                <template #default>
                  <DxRequiredRule message="Persoana de contact este obligatorie" />
                  <DxDropDownBox v-model:opened="isContacteGridBoxOpened" :data-source="contactSelectat"
                    v-model:value="sContact" :show-clear-button="true" display-expr="FullName" value-expr="ID"
                    placeholder="Selectează contact" :drop-down-options="{ width: 650, height: 400 }" :read-only="true">

                    <template #content="{ data }">
                      <DxDataGrid :data-source="dsContacts" :selected-row-keys="sContact ? [sContact] : []"
                        :hover-state-enabled="true" height="100%" @selection-changed="onValueSelectedContact($event)">
                        <DxSelection mode="single" />
                        <DxScrolling mode="virtual" />
                        <DxFilterRow :visible="true" />
                        <DxSearchPanel :visible="true" placeholder="Caută..." />

                        <DxColumn data-field="Nume" caption="Nume" />
                        <DxColumn data-field="Prenume" caption="Prenume" />

                        <DxGridToolbar>
                          <DxGridToolbarItem location="after">
                            <DxButton icon="plus" type="success" height="25px" width="25px" @click="onAddNewContact" />
                          </DxGridToolbarItem>
                          <DxGridToolbarItem name="searchPanel" />
                        </DxGridToolbar>
                      </DxDataGrid>

                    </template>
                  </DxDropDownBox>
                </template>
              </DxFormItem>
              <DxFormItem data-field="Data" editor-type="dxDateBox" :col-span="1" :editor-options="{
                type: 'datetime',
                displayFormat: 'dd/MM/yyyy ',
                dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ',
                useMaskBehavior: true
              }">
                <DxLabel text="Data " />
              </DxFormItem>

              <DxFormItem dataField="SursaID" :editorType="'dxSelectBox'" :editor-options="{
                displayExpr: 'Nume',
                valueExpr: 'ID',
                dataSource: dsSalesSources,
                placeholder: 'Selectează',
                showClearButton: true
              }">
                <DxRequiredRule message="Sursa lead este obligatorie" />
                <DxLabel text="Sursă Lead" />
              </DxFormItem>



            </DxFormItem>

            <!-- TAB 4 -->
            <DxFormItem item-type="group" :caption="tabs[3]" :col-span="3" :col-count="3"
              css-class="form-section-simple form-section-card">

              <DxFormItem dataField="BugetEstimat" editorType="dxNumberBox" :editor-options="{
                format: '#0.00',
                showSpinButtons: true
              }" />
              <DxFormItem dataField="ProbabilitateCastig" editorType="dxSelectBox"
                :label="{ text: 'Șansa de Câștig (%)' }" :editor-options="{
                  dataSource: probabilityList,
                  placeholder: 'Selectează %',
                  showClearButton: true
                }" />
              <DxFormItem :label="{ text: 'Valută' }">
                <template #default>
                  <DxDropDownBox v-model:opened="isValutaGridBoxOpened" :data-source="valutaSelectat"
                    v-model:value="sValuta" :show-clear-button="true" display-expr="Simbol" value-expr="Id"
                    placeholder="RON">
                    <template #content="{ data }">
                      <DxDataGrid :data-source="dsValuta" :selected-row-keys="sValuta ? [sValuta] : []"
                        :columns="['Simbol']" :hover-state-enabled="true" height="100%"
                        @selection-changed="onValuteRowClick($event)">
                        <DxSelection mode="single" />
                        <DxPaging :enabled="true" :page-size="5" />
                        <DxFilterRow :visible="true" />
                        <DxSearchPanel :visible="true" placeholder="Caută..." />
                      </DxDataGrid>
                    </template>
                  </DxDropDownBox>
                </template>
              </DxFormItem>
              <DxFormItem data-field="IntervalCumparare" editor-type="dxSelectBox" :editor-options="{
                dataSource: intervalList,
                valueExpr: 'name',
                displayExpr: 'name',
                searchEnabled: true,
                placeholder: 'Necunoscut',
                showClearButton: true
              }">
                <DxLabel text="Interval Cumpărare" />
              </DxFormItem>
              <DxFormItem dataField="DataInchidereEstimat" editorType="dxDateBox" :editor-options="{
                displayFormat: 'dd/MM/yyyy',
                dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ'
              }" />

              <DxFormItem :label="{ text: 'Campanie' }" :col-span="2">
                <DxDropDownBox v-model:opened="isCampaniiGridBoxOpened" :data-source="campanieSelectat"
                  v-model:value="sCampanie" :show-clear-button="true" display-expr="Denumire" value-expr="ID"
                  placeholder="Selectează campanie" :drop-down-options="{ width: 450 }">
                  <template #content="{ data }" style="height: 300px;">
                    <DxDataGrid :data-source="dsCampaniiMarketing" :selected-row-keys="sCampanie ? [sCampanie] : []"
                      :columns="['Denumire']" :hover-state-enabled="true" :height="300"
                      @selection-changed="onValueSelectedCampanie($event)">
                      <DxSelection mode="single" />
                      <DxScrolling mode="virtual" />
                      <DxFilterRow :visible="true" />
                      <DxSearchPanel :visible="true" placeholder="Cauta ..." />
                    </DxDataGrid>
                  </template>
                </DxDropDownBox>
              </DxFormItem>

              <DxFormItem dataField="Note" editor-type="dxTextArea" :editor-options="{ height: 100 }" :col-span="3">
                <DxLabel text="Observații" />
              </DxFormItem>
            </DxFormItem>
          </DxForm>
        </div>

        <div class="form-footer footer-fixed footer-modern">

          <div class="footer-right">
            <DxButton text="Salvează" type="success" width="120" height="32" styling-mode="outlined"
              @click="onSaveAdd" />
            <DxButton text="Închide" type="danger" width="120" height="32" styling-mode="outlined" @click="onCancel" />
          </div>
        </div>
      </div>
    </DxPopupAdd>

    <DxPopupAdd :visible="isPartnerModalVisible" :width="1450" :height="684" :show-title="true"
      title="Adăugare Partener Nou" @hiding="isPartnerModalVisible = false">
      <template #title>
        <div class="popup-header">
          <div class="popup-header-main">
            <span class="popup-header-icon dx-icon-add"></span>
            <div class="popup-header-texts">
              <div class="popup-header-title">Adăugare partener</div>
              <div class="popup-header-subtitle">
                Completează detaliile partenerului
              </div>
            </div>
          </div>
          <div class="popup-header-meta">
            <span class="status-chip status-chip--draft">
              Nou
            </span>
          </div>
        </div>
      </template>
      <div class="popup-body-modern">
        <DxForm :form-data="newPartnerData" :col-count="3" :col-span="3">

          <DxFormItem item-type="group" caption="Identitate & Fiscal" :col-count="6"
            css-class="form-section-simple form-section-card">
            <DxFormItem data-field="CUI" :label="{ text: 'CUI/CNP' }" :editor-options="cuiOptions" :col-span="3" />
            <DxFormItem data-field="Nume" :col-span="3" />


            <DxFormItem data-field="Fiscal" editor-type="dxSelectBox" :col-span="4" :label="{ text: 'Tip Fiscal' }"
              :editor-options="{
                dataSource: dsParteneriFiscal,
                displayExpr: 'Nume',
                valueExpr: 'Cod',
                placeholder: 'Selectează Tip Fiscal',
              }">
              <DxRequiredRule message="Câmpul 'Tip Fiscal' este obligatoriu" />
            </DxFormItem>
            <DxFormItem data-field="Numar" :label="{ text: 'Regim Comerț' }" :col-span="2" />
            <DxFormItem data-field="Caen" :label="{ text: 'Cod CAEN' }" :col-span="2" />

            <DxFormItem data-field="Owner" :editor-options="{ readOnly: true }" :label="{ text: 'Responsabil' }"
              :col-span="2" />
            <DxFormItem data-field="Cont" :label="{ text: 'IBAN' }" :col-span="2" />
            <DxFormItem data-field="Memo" :col-span="6" :editor-options="{ height: 80 }" editor-type="dxTextArea" />
          </DxFormItem>

          <DxFormItem item-type="group" caption="Sediu Social" :col-span="1" :col-count="4"
            css-class="form-section-simple form-section-card">

            <DxFormItem data-field="Strada" :col-span="3" />
            <DxFormItem data-field="Numarstrada" :col-span="1" :label="{ text: 'Nr.' }" />

            <DxFormItem data-field="Bloc" :col-span="1" />
            <DxFormItem data-field="Scarabloc" :col-span="1" :label="{ text: 'Sc.' }" />
            <DxFormItem data-field="Et" :col-span="1" :label="{ text: 'Etaj' }" />
            <DxFormItem data-field="Ap" :col-span="1" :label="{ text: 'Ap.' }" />

            <DxFormItem data-field="Localitate" :col-span="3" />
            <DxFormItem data-field="CP" :col-span="1" :label="{ text: 'C.P.' }" />

            <DxFormItem data-field="Adresa" :col-span="4" editor-type="dxTextArea" :editor-options="{ height: 80 }"
              :label="{ text: 'Adresă Completă' }" />
          </DxFormItem>

          <DxFormItem item-type="group" caption="Domiciliu Fiscal" :col-span="1" :col-count="4"
            css-class="form-section-simple form-section-card">
            <DxFormItem data-field="CStrada" :col-span="3" :label="{ text: 'Strada' }" />
            <DxFormItem data-field="CNumarstrada" :col-span="1" :label="{ text: 'Nr.' }" />

            <DxFormItem data-field="CBloc" :col-span="1" :label="{ text: 'Bl.' }" />
            <DxFormItem data-field="CScarabloc" :col-span="1" :label="{ text: 'Sc.' }" />
            <DxFormItem data-field="CEt" :col-span="1" :label="{ text: 'Etaj' }" />
            <DxFormItem data-field="CAp" :col-span="1" :label="{ text: 'Ap.' }" />

            <DxFormItem data-field="CLocalitate" :col-span="3" :label="{ text: 'Localitate' }" />
            <DxFormItem data-field="CCP" :col-span="1" :label="{ text: 'C.P.' }" />

            <DxFormItem data-field="CAdresa" :col-span="4" editor-type="dxTextArea" :editor-options="{ height: 80 }"
              :label="{ text: 'Adresă Completă' }" />
          </DxFormItem>

          <DxFormItem :col-count="3" :col-span="3">
            <div class="show-more-container" style="display: flex; justify-content: center; margin: 1px 0;">
              <DxButton :element-attr="{ class: 'show-more-btn' }"
                :text="showExtendedDetails ? 'Ascunde detalii suplimentare' : 'Completează detalii suplimentare'"
                :icon="showExtendedDetails ? 'chevronup' : 'chevrondown'" type="normal" styling-mode="text"
                @click="showExtendedDetails = !showExtendedDetails" />

            </div>
          </DxFormItem>

          <DxFormItem item-type="group" caption="Configurare Financiară & Comericală" :visible="showExtendedDetails"
            :col-count="2">
            <DxFormItem :label="{ text: 'Bancă (Internă)' }">
              <DxDropDownBox v-model:value="sBanci" :data-source="dsBanci" display-expr="Nume" value-expr="Id"
                :show-clear-button="true" placeholder="Selectează bancă" content-template="gridContent"
                :drop-down-options="{ width: 200 }">
                <template #gridContent>
                  <div class="dropdown-grid-container" style="height: 300px;">
                    <DxDataGrid :data-source="dsBanci" :columns="['Nume']" :hover-state-enabled="true" :height="280"
                      :remote-operations="true" @row-click="onBanciRowClick">
                      <DxPaging :enabled="true" :page-size="5" />
                      <DxFilterRow :visible="true" />
                      <DxScrolling mode="virtual" />
                      <DxGridToolbar>
                        <DxGridToolbarItem location="after">
                          <DxButton icon="plus" type="success" height="25px" width="25px" @click="onAddNewBank" />
                        </DxGridToolbarItem>
                        <DxGridToolbarItem name="searchPanel" />
                      </DxGridToolbar>
                    </DxDataGrid>
                  </div>
                </template>
              </DxDropDownBox>
            </DxFormItem>

            <DxFormItem :label="{ text: 'Valută' }">
              <DxDropDownBox v-model:opened="isPartnerValutaGridBoxOpened" :data-source="valutaSelectat"
                v-model:value="sValuta" :show-clear-button="true" display-expr="Simbol" value-expr="Id"
                placeholder="RON">
                <template #content="{ data }">
                  <DxDataGrid :data-source="dsValuta" :selected-row-keys="sValuta ? [sValuta] : []"
                    :columns="['Simbol']" :hover-state-enabled="true" height="100%"
                    @selection-changed="onValueSelectedPartnerValuta($event)">
                    <DxSelection mode="single" />
                    <DxPaging :enabled="true" :page-size="5" />
                    <DxFilterRow :visible="true" />
                    <DxSearchPanel :visible="true" placeholder="Caută..." />
                  </DxDataGrid>
                </template>
              </DxDropDownBox>
            </DxFormItem>

            <DxFormItem data-field="CapitalSocial" />
            <DxFormItem data-field="CifraAfacere" />

            <DxFormItem :label="{ text: 'Grup' }" :col-span="1">
              <DxDropDownBox v-model:value="sGrupuri" :data-source="dsGrupuri" display-expr="Nume" value-expr="Id"
                :show-clear-button="true" placeholder="Selectează " content-template="gridContent"
                :drop-down-options="{ width: 400 }">
                <template #gridContent>
                  <div class="dropdown-grid-container" style="height: 300px;">
                    <DxDataGrid :data-source="dsGrupuri" :columns="['Nume']" :hover-state-enabled="true" :height="280"
                      :remote-operations="true" @row-click="onGrupuriRowClick">
                      <DxPaging :enabled="true" :page-size="5" />
                      <DxFilterRow :visible="true" />
                      <DxScrolling mode="virtual" />
                    </DxDataGrid>
                  </div>
                </template>
              </DxDropDownBox>
            </DxFormItem>

            <DxFormItem :label="{ text: 'Zona' }" :col-span="1">
              <DxDropDownBox v-model:value="sZona" :data-source="dsZona" display-expr="Nume" value-expr="Id"
                :show-clear-button="true" placeholder="Selectează " content-template="gridContent"
                :drop-down-options="{ width: 200 }">
                <template #gridContent>
                  <div class="dropdown-grid-container" style="height: 300px;">
                    <DxDataGrid :data-source="dsZona" :columns="[
                      { dataField: 'Nume', caption: 'Nume' }
                    ]" :hover-state-enabled="true" :height="280" :remote-operations="true" @row-click="onZonaRowClick">
                      <DxPaging :enabled="true" :page-size="5" />
                      <DxFilterRow :visible="true" />
                      <DxScrolling mode="virtual" />
                    </DxDataGrid>
                  </div>
                </template>
              </DxDropDownBox>
            </DxFormItem>

            <DxFormItem data-field="AdaosPret" :col-span="1" />
            <DxFormItem data-field="Scadenta" :col-span="1" />

          </DxFormItem>

          <DxFormItem item-type="group" caption="Contacte & Diverse" :visible="showExtendedDetails" :col-count="2">
            <DxFormItem data-field="Tel" :label="{ text: 'Telefon' }" />
            <DxFormItem data-field="Fax" />
            <DxFormItem data-field="Email" />

            <DxFormItem data-field="Director" />



            <DxFormItem data-field="Observatii" :col-span="2" :editor-options="{ height: 100 }"
              editor-type="dxTextArea" />

          </DxFormItem>

          <DxFormItem item-type="group" caption="System Flags" :visible="showExtendedDetails" :col-count="2"
            :col-span="2">
            <DxFormItem data-field="AplicaTVAlaIncasare" editor-type="dxCheckBox"
              :label="{ text: 'TVA la Încasare' }" />
            <DxFormItem data-field="AplicaTvaDefalcat" editor-type="dxCheckBox" :label="{ text: 'Split TVA' }" />

            <DxFormItem data-field="RegimSpecialTVA" editor-type="dxCheckBox" />
            <DxFormItem data-field="Client" editor-type="dxCheckBox" />
            <DxFormItem data-field="Furnizor" editor-type="dxCheckBox" />
            <DxFormItem data-field="Activ" editor-type="dxCheckBox" />
            <DxFormItem data-field="Litigiu" editor-type="dxCheckBox" />
            <DxFormItem data-field="ExternUE" editor-type="dxCheckBox" />
            <DxFormItem data-field="Extern" editor-type="dxCheckBox" />
            <DxFormItem data-field="faraScadenta" editor-type="dxCheckBox" />
            <DxFormItem data-field="CalculezPenalitati" editor-type="dxCheckBox" />
          </DxFormItem>

        </DxForm>
        <div class="form-footer  footer-modern">
          <div class="footer-right" style="margin-top: 1px; text-align: right;">
            <DxButton text="Salvează Compania" type="success" @click="onSaveNewPartner" height="32px" width="200px"
              styling-mode="outlined" />
            <DxButton text="Închide" @click="isPartnerModalVisible = false" height="32px" width="200px"
              styling-mode="outlined" />
          </div>
        </div>
      </div>
    </DxPopupAdd>

    <DxPopupAdd :visible="isBankModalVisible" :width="800" :height="550" :show-title="true" title="Adăugare Bancă"
      @hiding="isBankModalVisible = false">
      <template #title>
        <div class="popup-header">
          <div class="popup-header-main">
            <span class="popup-header-icon dx-icon-add"></span>
            <div class="popup-header-texts">
              <div class="popup-header-title">Adăugare bancă</div>
              <div class="popup-header-subtitle">
                Completează detaliile băncii
              </div>
            </div>
          </div>
          <div class="popup-header-meta">
            <span class="status-chip status-chip--draft">
              Nou
            </span>
          </div>
        </div>
      </template>
      <div class="popup-body-modern">
        <DxForm :form-data="newBankData" :col-count="2" :col-span="2">

          <DxFormItem data-field="Ordine" />
          <DxFormItem data-field="Cod" />
          <DxFormItem data-field="Nume" />

          <DxFormItem :label="{ text: 'Valută' }">
            <DxDropDownBox v-model:value="sValute" :data-source="dsValute" display-expr="Nume" value-expr="Id"
              :show-clear-button="true" placeholder="Selectează " content-template="gridContent">
              <template #gridContent>
                <div class="dropdown-grid-container" style="height: 300px;">
                  <DxDataGrid :data-source="dsValute" :columns="['Nume']" :hover-state-enabled="true" :height="280"
                    :remote-operations="true" @row-click="onValuteRowClick">
                    <DxPaging :enabled="true" :page-size="5" />
                    <DxFilterRow :visible="true" />
                    <DxScrolling mode="virtual" />
                  </DxDataGrid>
                </div>
              </template>
            </DxDropDownBox>
          </DxFormItem>
          <DxFormItem data-field="CodIBAN" />
          <DxFormItem data-field="CodBIC" />
          <DxFormItem data-field="CodSWIFT" />
          <DxFormItem data-field="TextFC" />
          <DxFormItem data-field="Principala" editor-type="dxCheckBox" />
          <DxFormItem data-field="Activ" editor-type="dxCheckBox" />
        </DxForm>
        <div class="form-footer footer-fixed footer-modern">
          <div class="footer-right" style="margin-top: 10px; text-align: right;">
            <DxButton text="Salvează Banca" type="success" @click="onSaveNewBank" height="32px" width="200px"
              styling-mode="outlined" />
            <DxButton text="Închide" @click="isBankModalVisible = false" height="32px" width="200px"
              styling-mode="outlined" />
          </div>
        </div>
      </div>
    </DxPopupAdd>

    <DxPopupAdd :visible="isContactModalVisible" @hiding="isContactModalVisible = false" :closeOnOutsideClick="false"
      :showCloseButton="false" :showTitle="true" :width="800" :height="560">

      <template #title>
        <div class="popup-header">
          <div class="popup-header-main">
            <span class="popup-header-icon dx-icon-add"></span>
            <div class="popup-header-texts">
              <div class="popup-header-title">Adăugare contact</div>
              <div class="popup-header-subtitle">
                Completează detaliile contactului în pașii de mai jos
              </div>
            </div>
          </div>
          <div class="popup-header-meta">
            <span class="status-chip status-chip--draft">
              Nou
            </span>
          </div>
        </div>
      </template>

      <div class="popup-body-simple popup-body-modern">
        <div class="form-content form-content-modern">
          <DxForm :form-data="contactData" :col-count="3" :col-span="3" label-alignment="center" ref="form">
            <DxFormItem data-field="Nume" :col-span="1" :col-count="1">
              <DxRequiredRule message="Câmpul Nume este obligatoriu" />
            </DxFormItem>
            <DxFormItem data-field="Prenume" :col-span="1" :col-count="1">
              <DxRequiredRule message="Câmpul Prenume este obligatoriu" />
            </DxFormItem>

            <DxFormItem data-field="Titlu" :label="{ text: 'Funcția' }" :col-span="1" :col-count="1">

              <DxRequiredRule message="Funcția este obligatorie" />
            </DxFormItem>
            <DxFormItem :label="{ text: 'Partener' }" :col-span="2" :col-count="2">
              <DxRequiredRule message="Partenerul este obligatoriu" />
              <DxDropDownBox v-model:value="sContactPartener" v-model:opened="isContactPartenerGridBoxOpened"
                :data-source="dsParteneri" display-expr="Nume" value-expr="ID" :show-clear-button="true"
                placeholder="Selectează partener" content-template="gridContent">
                <template #gridContent>
                  <div class="dropdown-grid-container" style="height: 300px;">
                    <DxDataGrid :data-source="dsParteneri" :columns="['Nume']" :hover-state-enabled="true" :height="280"
                      :remote-operations="true" @row-click="onContactPartenerRowClick">
                      <DxPaging :enabled="true" :page-size="5" />
                      <DxFilterRow :visible="true" />
                      <DxScrolling mode="virtual" />
                      <DxGridToolbar>
                        <DxGridToolbarItem location="after">
                          <DxButton icon="plus" type="success" height="25px" width="25px" @click="onAddNewPartener" />
                        </DxGridToolbarItem>
                        <DxGridToolbarItem name="searchPanel" />
                      </DxGridToolbar>
                    </DxDataGrid>
                  </div>
                </template>
              </DxDropDownBox>
            </DxFormItem>

            <DxFormItem data-field="MetodaContact" :label="{ text: 'Metodă Contact' }" editor-type="dxSelectBox"
              :editor-options="{
                items: metodaContact,
                placeholder: 'Selectează metoda de contact'
              }">
              <DxRequiredRule message="Metoda de contact este obligatorie" />
            </DxFormItem>
            <DxFormItem data-field="TelMobil" :label="{ text: 'Telefon' }"
              :is-required="contactData.MetodaContact === 'Telefonic'" />
            <DxFormItem data-field="Email" :label="{ text: 'Email' }"
              :is-required="contactData.MetodaContact === 'Email'" />
            <DxFormItem dataField="Adresa" :label="{ text: 'Adresă' }" :col-span="3" />

            <DxFormItem :label="{ text: 'Țară' }" :col-span="1">
              <DxDropDownBox :data-source="dsTari" v-model:value="sContactTara"
                v-model:opened="isContactTaraGridBoxOpened" :show-clear-button="true" display-expr="Nume"
                value-expr="ID" placeholder="Selectează țara" content-template="gridContent">
                <template #gridContent>
                  <div class="dropdown-grid-container" style="height: 300px;">
                    <DxDataGrid :data-source="dsTari" :columns="['Nume']" :remote-operations="true"
                      :selected-row-keys="sContactTara ? [sContactTara] : []" :hover-state-enabled="true" height="100%"
                      @selection-changed="onContactValueSelectedTara($event)">
                      <DxSelection mode="single" />
                      <DxPaging :enabled="true" :page-size="5" />
                      <DxFilterRow :visible="true" />
                      <DxSearchPanel :visible="true" placeholder="Caută ..." />
                    </DxDataGrid>
                  </div>
                </template>
              </DxDropDownBox>
            </DxFormItem>

            <DxFormItem :label="{ text: 'Județ' }">
              <DxDropDownBox v-model:opened="isContactJudetGridBoxOpened" v-model:value="sContactJudet"
                :show-clear-button="true" display-expr="Nume" value-expr="ID" placeholder="Selectează județul">
                <template #content="{ data }">
                  <div class="dropdown-grid-container" style="height: 300px;">
                    <DxDataGrid :data-source="dsJudete" :columns="['Nume']"
                      :selected-row-keys="sContactJudet ? [sContactJudet] : []" :hover-state-enabled="true"
                      height="100%" @selection-changed="onContactValueSelectedJudet($event)">
                      <DxSelection mode="single" />
                      <DxPaging :enabled="true" :page-size="5" />
                      <DxFilterRow :visible="true" />
                      <DxSearchPanel :visible="true" placeholder="Caută ..." />
                    </DxDataGrid>
                  </div>
                </template>
              </DxDropDownBox>
            </DxFormItem>

            <DxFormItem :label="{ text: 'Localitate' }" :col-span="1">
              <DxDropDownBox :data-source="dsLocalitati" v-model:value="sContactLocalitate"
                v-model:opened="isContactLocalitateGridBoxOpened" :show-clear-button="true" display-expr="Localitate"
                value-expr="ID" placeholder="Selectează localitatea" content-template="gridContent">
                <template #gridContent>
                  <div class="dropdown-grid-container" style="height: 300px;">
                    <DxDataGrid :data-source="dsLocalitati" :columns="['Localitate']" :remote-operations="true"
                      :selected-row-keys="sContactLocalitate ? [sContactLocalitate] : []" :hover-state-enabled="true"
                      height="100%" @selection-changed="onContactValueSelectedLocalitate($event)">
                      <DxSelection mode="single" />
                      <DxPaging :enabled="true" :page-size="5" />
                      <DxFilterRow :visible="true" />
                      <DxSearchPanel :visible="true" placeholder="Caută ..." />
                    </DxDataGrid>
                  </div>
                </template>
              </DxDropDownBox>
            </DxFormItem>
            <DxFormItem data-field="Note" :col-span="3" :editor-options="{ height: 80 }" editor-type="dxTextArea" />
          </DxForm>
        </div>

        <div class=" footer-fixed footer-modern">
          <div class="footer-right">
            <DxButton text="Salvează" type="success" width="120" height="32" styling-mode="outlined"
              :disabled="!contactData.AccountID" @click="onSaveAddContact" />
            <DxButton text="Închide" type="danger" width="120" height="32" styling-mode="outlined"
              @click="onCancelContact" />
          </div>
        </div>
      </div>
    </DxPopupAdd>


  </div>
</template>
<script lang="ts">
import DxSelectBox from "devextreme-vue/select-box"
import DxDropDownButton, { DxDropDownButtonTypes } from 'devextreme-vue/drop-down-button';
import { defineComponent, ref } from 'vue';
import { DxButton } from 'devextreme-vue/button';
import DxPopupAdd from 'devextreme-vue/popup';
import { DxSimpleItem, DxLabel } from 'devextreme-vue/form';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import { locale, loadMessages } from 'devextreme/localization';
import PAR_Parteneri from "@/services/PAR/PAR_Parteneri";
import {
  DxItem as DxGridToolbarItem,
  DxLookup,
  DxColumn,
  DxDataGrid,
  DxFilterRow,
  DxLoadPanel,
  DxPaging,
  DxSelection,
  DxSorting,
  DxStateStoring,
  DxToolbar as DxGridToolbar,
  DxEditing,
  DxColumnChooser,
  DxGrouping,
  DxGroupPanel,
  DxTexts,
  DxExport,
  DxSearchPanel,
  DxMasterDetail,
  DxPopup,
  DxToolbarItem,
  DxForm as DxFormGrid,
  DxItem as DxFormItemGrid,
  DxScrolling,
  DxHeaderFilter
} from 'devextreme-vue/data-grid';
import AnafService from '@/services/AnafService';
import CrmContacts from '@/services/Comercial/CrmContacts';
import DxValidator, { DxRequiredRule, DxCustomRule } from 'devextreme-vue/validator'
import { DxForm, DxItem as DxFormItem } from 'devextreme-vue/form';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import notify from 'devextreme/ui/notify';
import { jsPDF } from 'jspdf';
import { exportDataGrid as exportDataGridPdf } from 'devextreme/pdf_exporter';
import { exportDataGrid as exportDataGridExcel } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import CrmSales from '@/services/Comercial/CrmSales';
import JwtServices from '@/services/JwtServices';
import DataSource from "devextreme/data/data_source";
import DxDropDownBox from "devextreme-vue/drop-down-box";
import { DxGroupItem } from "devextreme-vue/form"
export default defineComponent({
  components: {
    DxGridToolbar,
    DxDataGrid,
    DxColumn,
    DxSorting,
    DxSelection,
    DxFilterRow,
    DxStateStoring,
    DxLoadPanel,
    DxPaging,
    DxButton,
    DxEditing,
    DxPopupAdd,
    DxFormItem,
    DxFormItemGrid,
    DxSimpleItem,
    DxLabel,
    DxScrollView,
    DxLookup,
    DxColumnChooser,
    DxGrouping,
    DxGroupPanel,
    DxTexts,
    DxExport,
    DxSearchPanel,
    DxMasterDetail,
    DxPopup,
    DxToolbarItem,
    DxFormGrid,
    DxGridToolbarItem,
    DxScrolling,
    DxHeaderFilter,
    DxDropDownButton,
    DxDropDownBox,
    DxForm,
    DxSelectBox,
    DxGroupItem,
    DxRequiredRule
  },
  props: {
    contactId: {
      type: String,
      required: false
    },
    contactData: {
      type: Object,
      required: false
    },
    accountId: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      probabilityList: [0, 25, 50, 75, 100],
      judetSelectat: [],
      localitateSelectat: [],
      taraSelectat: [],

      // Variables for Contact Popup
      sContactPartener: null,
      isContactPartenerGridBoxOpened: false,
      sContactTara: null,
      contactTaraSelectat: [],
      isContactTaraGridBoxOpened: false,
      sContactJudet: null,
      contactJudetSelectat: [],
      isContactJudetGridBoxOpened: false,
      sContactLocalitate: null,
      contactLocalitateSelectat: [],
      isContactLocalitateGridBoxOpened: false,
      contactData: {
        Nume: '',
        Prenume: null,
        DataNasterii: null,
        Titlu: '',
        AccountID: null,
        Email: '',
        TelMunca: '',
        TelMobil: '',
        Fax: '',
        TaraID: '',
        JudetID: null,
        LocalitateID: null,
        Adresa: '',
        MetodaContact: '',
        Note: '',
        Activ: true,
        Owner: '',
        Imagine: null,
        ContactPrimar: true
      },
      metodaContact: [
        'Telefonic',
        'Email'
      ],
      isPartnerModalVisible: false,
      isContactModalVisible: false,
      newPartnerData: {
        Nume: '',
        CUI: '',
        Cod: '',
        Fiscal: '',
        Client: null,
        Furnizor: null,
        Numar: '',
        Strada: '',
        Localitate: '',
        JudetID: null,
        TaraID: null,
        ZonaID: null,
        Cont: '',
        Banca: '',
        Litigiu: null,
        Extern: null,
        Intern: null,
        Observatii: '',
        AdaosPret: null,
        faraScadenta: null,
        ValutaID: '0A61647E-7391-4087-BC01-8EB9C2CEDEDD',
        Director: '',
        Fax: '',
        Tel: '',
        Email: '',
        www: '',
        GrupID: null,
        CP: '',
        CStrada: '',
        CLocalitate: '',
        CJudetID: null,
        CTaraID: null,
        CCP: '',
        Bloc: '',
        CBloc: '',
        Numarstrada: '',
        Scarabloc: '',
        CNumarstrada: '',
        CScarabloc: '',
        Scadenta: null,
        AgentID: null,
        Angajat: null,
        Memo: '',
        CreditLimita: null,
        DirectorEconomic: '',
        PersoanaContact: '',
        AplicaTVAlaIncasare: null,
        CifraAfacere: null,
        NrAngajati: null,
        Activ: null,
        Owner: '',
        CalculezPenalitati: null,
        ParRecomandareID: null,
        CapitalSocial: null,
        AngajatID: null,
        ExternUE: null,
        StructuraLegaturaID: null,
        PartenerMasterID: null,
        RegimSpecialTVA: null,
        AplicaTvaDefalcat: null,
        Et: '',
        Ap: '',
        Adresa: '',
        CEt: '',
        CAp: '',
        CAdresa: '',
        CalculezPenalitatiDeLa: null,
        Prefix: '',
        Sufix: '',
        Caen: '',
        PunctID: null,
        ParentID: null,
      },
      tabs: [
        "Info. General",
        "Relații",
        "Info. Financiar",
        "Achiziție",
        "Detalii"
      ],
      cuiOptions: {
        placeholder: 'Introdu CUI',
        buttons: [{
          name: 'searchAnaf',
          location: 'after',
          options: {
            icon: 'search',
            width: 26,
            height: 26,
            type: 'default',
            hint: 'Caută în ANAF',
            onClick: () => this.onSearchAnaf()
          }
        }]
      },

      intervalList: [
        { name: 'Imediat' },
        { name: 'Luna aceasta' },
        { name: 'Anul acesta' },
        { name: 'Trimestrul acesta' },
        { name: 'Trimestrul următor' },
        { name: 'Necunoscut' },
      ],
      partenerSelectat: [],
      isParteneriGridBoxOpened: false,
      sPartener: null,
      isAccountDdbOpen: false as boolean,
      isIndustrieDdbOpen: false as boolean,
      isCampanieDdbOpen: false as boolean,
      dsSalesSources: {} as ODataStore,
      contactSelectat: [],
      sStatus: null,
      isValutaGridBoxOpened: false,
      isContacteGridBoxOpened: false,
      sContact: null,
      Username: '',
      industrieSelectat: [],
      isIndustrieGridBoxOpened: false,
      sIndustrie: null,
      isJudetGridBoxOpened: false,
      sJudet: null,
      isLocalitateGridBoxOpened: false,
      sLocalitate: null,
      isTaraGridBoxOpened: false,
      sTara: null,
      campanieSelectat: [],
      isCampaniiGridBoxOpened: false,
      sCampanie: null,
      valutaSelectat: [],
      isValuteGridBoxOpened: false,
      isPartnerValutaGridBoxOpened: false,
      sValuta: null,
      dsContacts: {} as ODataStore,
      dsParteneri: {} as DataSource,
      dsIndustrii: {} as ODataStore,
      dsValuta: {} as ODataStore,
      dsCampaniiMarketing: {} as ODataStore,
      dsValute: {} as ODataStore,
      dsSursa: {} as ODataStore,
      dsSursaMap: new Map<string, string>(),
      dsProiect: {} as ODataStore,
      dsProiecte: {} as ODataStore,
      dsProiectMap: new Map<string, string>(),
      dsSales: {} as any,
      dsParteneriFiscal: {} as ODataStore,
      dsStatus: {} as ODataStore,
      isModalVisible: false,
      isOpportunityDetailsVisible: false,
      isPanelOpened: ref(false),
      dataGrid: ref<DxDataGrid | null>(null),
      proiectSelectat: [],
      isProiecteGridBoxOpened: false,
      sProiect: null,
      deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
      sGrupuri: null,
      dsGrupuri: {} as ODataStore,
      selectedOpportunity: {
        Titlu: '',
        ContactID: null,
        AccountID: null,
        Sursa: '',
        IntervalCumparare: '',
        BugetEstimat: null,
        Note: '',
        Cerere: '',
        Oferta: '',
        DataInchidereEstimat: null,
        VenitEstimat: null,
        Probabilitate: null,
        Status: '',
        Owner: '',
        UserCreat: '',
        DataCreat: null,
        UserModificat: '',
        DataModificat: null,
        VenitRealizat: null,
        DataInchis: null,
        UltimulStatus: '',
        MotivInchidere: '',
        IndustrieID: null,
        CampanieID: null,
        CostEstimat: null,
        CostEfectiv: null,
        ListaProduse: '',
        Cod: '',
        Discount: null,
        ValutaID: null,
        Curs: null,
        SursaID: null,
        Data: null,
        ProiectID: null,
        Contact: '',
        Account: '',
        Industrie: '',
        Campanie: '',
        Valuta: '',

      },
      sBanci: null,
      dsBanci: {} as ODataStore,
      dsTari: {} as ODataStore,
      dsJudete: {} as ODataStore,
      dsLocalitati: {} as ODataStore,
      showExtendedDetails: false,
      formData: {
        Titlu: '',
        ContactID: null,
        AccountID: null as string | null,
        Sursa: '',
        IntervalCumparare: '',
        BugetEstimat: null,
        Note: '',
        Cerere: '',
        Oferta: '',
        DataInchidereEstimat: null,
        VenitEstimat: null,
        Probabilitate: null,
        // Status: '',
        Owner: '',
        UserCreat: '',
        DataCreat: null,
        UserModificat: '',
        DataModificat: null,
        VenitRealizat: null,
        DataInchis: null,
        UltimulStatus: '',
        MotivInchidere: '',
        IndustrieID: null,
        CampanieID: null,
        CostEstimat: null,
        CostEfectiv: null,
        ListaProduse: '',
        Cod: '',
        Discount: null,
        ValutaID: null,
        Curs: null,
        SursaID: null,
        Data: null,
        ProiectID: null,
        Campanie: '',
        Valuta: '',
        StatusID: 'BE62B2A3-AEA9-4706-ADED-934622DBEFD9',
        ProbabilitateCastig: null,
      },

      sValute: null,
      newBankData: {
        Ordine: null,
        PartenerID: null,
        Cod: '',
        Nume: '',
        ValutaID: null,
        CodIBAN: '',
        CodBIC: '',
        CodSWIFT: '',
        TextFC: '',
        Principala: false,
        Activ: true,
      },
      sZona: null,
      dsZona: {} as ODataStore,
      isBankModalVisible: false,
      successButtonOptions: {
        type: 'success',
        stylingMode: 'outlined',
        text: 'Salvează',
        onClick: () => {
          this.SaveEdit();
        },
      },
      dangerButtonOptions: {
        type: 'danger',
        stylingMode: 'outlined',
        text: 'Închide',
        onClick: () => {
          this.onCancel();
        },
      },
      customTitleTemplate() {
        return `
           <div class="popup-header" style="width: 800px; margin: -5px -20px 0 -20px; padding: 16px 24px; background: linear-gradient(90deg, #ff2c21, #ff6a4a); display: flex; align-items: center; gap: 16px;">
             <span class="dx-icon-edit" style="font-size: 24px;  width: 40px; height: 20px; display: flex; align-items: center; justify-content: center; border-radius: 8px; color: white;"></span>
             <div style="display: flex; flex-direction: column; color: white;">
                <span style="font-size: 16px; font-weight: 700;">Editare Oportunitate existentă</span>
                <span style="font-size: 12px; opacity: 0.9;">Modifică detaliile oportunității selectate</span>
             </div>
          </div>
        `;
      },
    };
  },
  watch: {
    sProiect(newId) {
      if (newId) {
        this.dsProiecte.store().byKey(newId).then(x => {
          if (!x) return;
          x.Cod = (x.Cod ?? '(fara nume)');
          this.proiectSelectat = [x];
        });

      } else {
        this.proiectSelectat = [];
      }
    },
    sContact(newId) {
      if (newId) {
        this.dsContacts.store().byKey(newId).then(x => {
          if (!x) return;
          x.FullName = `${x.Nume ?? ''} ${x.Prenume ?? ''}`.trim() || '(fara nume)';
          this.contactSelectat = [x];
        });
      } else {
        this.contactSelectat = [];
      }
    },
    sIndustrie(newId) {
      if (newId) {
        this.dsIndustrii.store().byKey(newId).then(x => {
          if (!x) return;
          x.Nume = (x.Nume ?? '(fara nume)');
          this.industrieSelectat = [x];
        });
      } else {
        this.industrieSelectat = [];
      }
    },
    sPartener(newId) {
      if (newId) {
        this.dsParteneri.store().byKey(newId).then(x => {
          if (!x) return;
          x.Nume = (x.Nume ?? '(fara nume)');
          this.partenerSelectat = [x];
        });

        // Clear contact when company changes
        // this.sContact = null;
        // this.formData.ContactID = null;

        this.dsContacts.filter(['AccountID', '=', newId]);
        this.dsContacts.load();

      } else {
        this.partenerSelectat = [];
        this.dsContacts.filter(null);
        this.dsContacts.load();
      }
    },
    sCampanie(newId) {
      if (newId) {
        this.dsCampaniiMarketing.store().byKey(newId).then(x => {
          if (!x) return;
          x.Denumire = (x.Denumire ?? '(fara nume)');
          this.campanieSelectat = [x];
        });

      } else {
        this.campanieSelectat = [];
      }
    },
    sValuta(newId) {
      if (newId) {
        this.dsValuta.store().byKey(newId).then(x => {
          if (!x) return;
          x.Nume = (x.Nume ?? '(fara nume)');
          this.valutaSelectat = [x];
        });

      } else {
        this.valutaSelectat = [];
      }
    },
    sParteneriFiscal(newId) {
      if (newId) {
        this.dsParteneriFiscal.store().byKey(newId).then(x => {
          if (!x) return;
          x.Nume = (x.Nume ?? '(fara nume)');
          this.partenerFiscalSelectat = [x];
        });
      } else {
        this.partenerFiscalSelectat = [];
      }
    },
    sLocalitate(newId) {
      if (newId) {
        this.dsLocalitati.store().byKey(newId).then(x => {
          if (!x) return;
          x.Localitate = (x.Localitate ?? '(fara nume)');
          this.localitateSelectat = [x];
        });

      } else {
        this.localitateSelectat = [];
      }
    },

    sTara(newId) {
      if (newId) {
        this.dsTari.store().byKey(newId).then(x => {
          if (!x) return;
          x.Nume = (x.Nume ?? '(fara nume)');
          this.taraSelectat = [x];
        });
      } else {
        this.taraSelectat = [];
      }
    },
    sJudet(newId) {
      if (newId) {
        this.dsJudete.store().byKey(newId).then(x => {
          if (!x) return;
          x.Nume = (x.Nume ?? '(fara nume)');
          this.judetSelectat = [x];
        });



      } else {
        this.judetSelectat = [];
      }
    },

    'formData.IntervalCumparare': function (newVal) {
      if (!newVal) return;
      const now = new Date();
      let newDate = null;

      switch (newVal) {
        case 'Imediat':
          // Current date + 2 weeks
          newDate = new Date(now.getTime() + 14 * 24 * 60 * 60 * 1000);
          break;
        case 'Luna aceasta':
          // Last day of current month
          newDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
          break;
        case 'Anul acesta':
          // Last day of current year
          newDate = new Date(now.getFullYear(), 11, 31);
          break;
        case 'Trimestrul acesta': {
          // Last day of current quarter
          const currentMonth = now.getMonth(); // 0-11
          const quarterEndMonth = Math.floor(currentMonth / 3) * 3 + 2;
          newDate = new Date(now.getFullYear(), quarterEndMonth + 1, 0);
          break;
        }
        case 'Trimestrul următor': {
          // Last day of next quarter
          const currentMonth = now.getMonth();
          const currentQuarter = Math.floor(currentMonth / 3);
          const nextQuarter = currentQuarter + 1;
          let targetYear = now.getFullYear();
          let targetQuarter = nextQuarter;

          if (nextQuarter > 3) {
            targetQuarter = 0;
            targetYear++;
          }
          const quarterEndMonth = targetQuarter * 3 + 2;
          newDate = new Date(targetYear, quarterEndMonth + 1, 0);
          break;
        }
        default:
          return;
      }

      if (newDate) {
        this.formData.DataInchidereEstimat = newDate;
      }
    },
  },

  computed: {
    gridFilter() {
      if (this.accountId) {
        return ['AccountID', '=', this.accountId];
      }
      if (this.contactId) {
        return ['ContactID', '=', this.contactId];
      }
      return ['ID', '=', '00000000-0000-0000-0000-000000000000'];
    }
  },
  methods: {
    // START: Main Form Handlers
    // onPartenerRowClick(e) {
    //   this.isParteneriGridBoxOpened = false;
    //   if (e.data) {
    //     this.sPartener = e.data.ID;
    //     this.formData.AccountID = e.data.ID;
    //   } else {
    //     this.sPartener = null;
    //     this.formData.AccountID = null;
    //   }
    // },
    // END: Main Form Handlers

    // START: Contact Popup Handlers
    onContactPartenerRowClick(e) {
      this.isContactPartenerGridBoxOpened = false;
      if (e.data) {
        this.sContactPartener = e.data.ID;
        this.contactData.AccountID = e.data.ID;
      } else {
        this.sContactPartener = null;
        this.contactData.AccountID = null;
      }
    },
    onContactValueSelectedTara(e) {
      this.isContactTaraGridBoxOpened = false;
      if (e.selectedRowKeys.length > 0) {
        this.sContactTara = e.selectedRowKeys[0];
      } else {
        this.sContactTara = null;
      }
      this.contactData.TaraID = this.sContactTara;

      let _filter;
      if (this.sContactTara != null) {
        _filter = ["TaraId", "=", this.sContactTara];
      } else {
        _filter = null;
      }
      this.dsJudete.filter(_filter);
      this.dsJudete.load();
    },
    onContactValueSelectedJudet(e) {
      this.isContactJudetGridBoxOpened = false;
      if (e.selectedRowKeys.length > 0) {
        this.sContactJudet = e.selectedRowKeys[0];
      } else {
        this.sContactJudet = null;
      }
      this.contactData.JudetID = this.sContactJudet;

      let _filter;
      if (this.sContactJudet != null) {
        _filter = ["JudetId", "=", this.sContactJudet];
      } else {
        _filter = null;
      }
      this.dsLocalitati.filter(_filter);
      this.dsLocalitati.load();
    },
    onContactValueSelectedLocalitate(e) {
      this.isContactLocalitateGridBoxOpened = false;
      if (e.selectedRowKeys.length > 0) {
        this.sContactLocalitate = e.selectedRowKeys[0];
      } else {
        this.sContactLocalitate = null;
      }
      this.contactData.LocalitateID = this.sContactLocalitate;
    },
    // END: Contact Popup Handlers
    onValueSelectedTara(e) {
      this.isTaraGridBoxOpened = false;

      if (e.selectedRowKeys.length > 0) {
        this.sTara = e.selectedRowKeys[0];

      } else {
        this.sTara = null;
      }
      this.formData.TaraID = this.sTara;

      let _filter;

      if (this.sTara != null) {
        _filter = ["TaraId", "=", this.sTara];
      } else {
        _filter = null;
      }

      this.dsJudete.filter(_filter);
      this.dsJudete.load();

    },
    onValueSelectedJudet(e) {
      this.isJudetGridBoxOpened = false;

      if (e.selectedRowKeys.length > 0) {
        this.sJudet = e.selectedRowKeys[0];

      } else {
        this.sJudet = null;
      }
      this.formData.JudetID = this.sJudet;

      let _filter;

      if (this.sJudet != null) {
        _filter = ["JudetId", "=", this.sJudet];
      } else {
        _filter = null;
      }

      this.dsLocalitati.filter(_filter);
      this.dsLocalitati.load();

    },
    onValueSelectedLocalitate(e) {
      this.isLocalitateGridBoxOpened = false;

      if (e.selectedRowKeys.length > 0) {
        this.sLocalitate = e.selectedRowKeys[0];

      } else {
        this.sLocalitate = null;
      }
      this.formData.LocalitateID = this.sLocalitate;
    },
    createODataContext() {
      this.dsJudete = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_ComercialOdata + 'ERP_Judete',
          key: 'ID',
          keyType: "Guid",
          version: 4,

          beforeSend: (e: any) => {

            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

            };
          }
        },
        select: [
          'ID',
          'Nume',
        ],

      });
      this.dsTari = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_ComercialOdata + 'ERP_Tari',
          key: 'ID',
          keyType: "Guid",
          version: 4,

          beforeSend: (e: any) => {

            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

            };
          }
        },
        select: [
          'ID',
          'Nume',
        ],

      });

      this.dsLocalitati = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_ComercialOdata + 'ERP_Localitati',
          key: 'ID',
          keyType: "Guid",
          version: 4,

          beforeSend: (e: any) => {

            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

            };
          }
        },
        select: [
          'ID',
          'Localitate',
        ],

      });
      this.dsStatus = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_ComercialOdata + 'CRM_StariOportunitati',
          key: 'ID',
          keyType: 'Guid',
          version: 4,
          fieldTypes: {
            ID: 'Guid'
          },
          beforeSend: (e: any) => {
            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
            };
          }
        },
        select: [
          'ID',
          'Nume',
          'Pondere'
        ],
        sort: [{ selector: "NrOrd", desc: false }]
      });

      this.dsValute = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_ComercialOdata + 'ERP_Valute',
          key: 'Id',
          keyType: "Guid",
          version: 4,

          beforeSend: (e: any) => {

            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

            };

          }
        },
        select: [
          'Id',
          'Nume',
        ],

      });
      this.dsZona = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_ComercialOdata + 'ERP_Zone',
          key: 'Id',
          keyType: "Guid",
          version: 4,

          beforeSend: (e: any) => {

            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

            };

          }
        },
        select: [
          'Id',
          'Nume',
        ],

      });
      this.dsGrupuri = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_ComercialOdata + 'PAR_Grupuri',
          key: 'Id',
          keyType: "Guid",
          version: 4,

          beforeSend: (e: any) => {

            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

            };

          }
        },
        select: [
          'Id',
          'Nume',
          'Cod'
        ],
        sort: [
          { selector: 'Cod', desc: false }
        ]

      });

      this.dsParteneriFiscal = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_ComercialOdata + 'PAR_ParteneriFiscal',
          key: 'ID',
          keyType: "Guid",
          version: 4,

          beforeSend: (e: any) => {

            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

            };
          }
        },
        select: [
          'Cod',
          'Nume',
        ],

      });
      this.dsBanci = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_ComercialOdata + 'PAR_BanciParteneri',
          key: 'Id',
          keyType: "Guid",
          version: 4,

          beforeSend: (e: any) => {

            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

            };

          }
        },
        select: [
          'Id',
          'Nume',
        ],

      });
      this.dsProiecte = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_DocumenteOdata + 'DOC_Proiecte',
          key: 'Id',
          keyType: "Guid",
          version: 4,

          beforeSend: (e: any) => {

            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

            };
          }
        },
        select: [
          'Id',
          'Cod',
        ],

      });
      // this.dsSalesSources = new DataSource({
      //   store: {
      //     type: 'odata',
      //     url: AppSetting.API_Url_ComercialOdata + 'CRM_SalesSources',
      //     key: 'ID',
      //     keyType: 'Guid', // OBLIGATORIU: "Int32" (cu I mare) pentru a elimina ghilimelele din URL
      //     version: 4,
      //     beforeSend: (e: any) => {
      //       e.headers = {
      //         "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
      //       };
      //     }
      //   },
      //   select: ['ID', 'Nume'],
      // });
      this.dsSalesSources = new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'CRM_SalesSources',
        key: 'ID',
        keyType: 'Guid',
        version: 4,
        beforeSend: (e) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
          };
        },
      });

      this.dsSales = new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'CRM_Sales',
        key: 'ID',
        keyType: "Guid",
        fieldTypes: {
          ContactID: 'Guid',
          AccountID: 'Guid',
          SursaID: 'Guid',
          StatusID: 'Guid',
          IndustrieID: 'Guid',
          CampanieID: 'Guid',
          ValutaID: 'Guid',
          ProiectID: 'Guid'
        },
        version: 4,
        beforeSend: (e) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
          };
          e.params.$expand = "Account($select=Nume),Contact($select=Nume,Prenume),Industrie($select=Nume),Campanie($select=Denumire),Valuta($select=Simbol),Proiect($select=Cod),Sursa($select=Nume),Status($select=Nume)";

        }
      });
      this.dsParteneri = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_ComercialOdata + 'PAR_Parteneri',
          key: 'ID',
          keyType: "Guid",
          version: 4,

          beforeSend: (e: any) => {

            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

            };
          }
        },
        select: [
          'ID',
          'Nume',
        ],

      });
      this.dsContacts = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_ComercialOdata + 'CRM_Contacts',
          key: 'ID',
          keyType: "Guid",
          version: 4,
          fieldTypes: {
            AccountID: 'Guid'
          },

          beforeSend: (e: any) => {

            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

            };
          }
        },
        select: [
          'ID',
          'Nume',
          'Prenume',
          'AccountID'
        ],

      });

      this.dsIndustrii = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_ComercialOdata + 'CRM_Industrii',
          key: 'ID',
          keyType: "Guid",
          version: 4,

          beforeSend: (e: any) => {

            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

            };
          }
        },
        select: [
          'ID',
          'Nume',
        ],

      });
      this.dsCampaniiMarketing = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_ComercialOdata + 'CRM_CautareCampaniiMarketing',
          key: 'ID',
          keyType: "Guid",
          version: 4,

          beforeSend: (e: any) => {

            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

            };
          }
        },
        select: [
          'ID',
          'Denumire',
        ],

      });

      this.dsValuta = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_ComercialOdata + 'ERP_Valute',
          key: 'Id',
          keyType: "Guid",
          version: 4,
          beforeSend: (e: any) => {
            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
            };
          }
        },
        // IMPORTANT: Adaugă 'Cod' aici dacă îl folosești în search-expr sau template
        select: ['Id', 'Simbol'],
      });
    },
    displayStatus(item) {
      return item ? (item.name || '(fara nume)') : '';
    },
    onAddNewContact() {
      this.contactData.AccountID = this.sPartener;
      this.sContactPartener = this.sPartener; // Initialize popup selection
      this.isContactModalVisible = true;
      this.contactData.TaraID = 'D31C3594-8D39-4355-9A13-FD699A1B7290'; // Default Country: Romania
    },
    onStatusRowClick(e) {
      this.isStatusGridBoxOpened = false;

      if (e.data) {
        this.sStatus = e.data.ID;
        this.formData.StatusID = e.data.ID;
      } else {
        this.sStatus = null;
      }
    },
    onGrupuriRowClick(e) {
      this.isGrupuriGridBoxOpened = false;

      if (e.data) {
        this.sGrupuri = e.data.Id;
        this.newPartnerData.GrupID = e.data.Id;
      } else {
        this.sGrupuri = null;
      }

    },
    onZonaRowClick(e) {
      this.isZonaGridBoxOpened = false;

      if (e.data) {
        this.sZona = e.data.Id;
        this.newPartnerData.ZonaID = e.data.Id;
      } else {
        this.sZona = null;
      }

    },
    // Normalizare diacritice + case pentru potrivirea numelui de județ primit de la ANAF
    // (ex: "BIHOR") cu nomenclatorul ERP_Judete (ex: "Bihor").
    normalizeazaText(text: string | null | undefined): string {
      return String(text ?? "")
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .toUpperCase()
        .trim();
    },
    async cautaJudetDupaNume(nume: string | null | undefined, taraId: string | null): Promise<{ ID: string; Nume: string } | null> {
      if (!nume || !taraId) return null;
      const store = new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'ERP_Judete', key: 'ID', keyType: 'Guid', version: 4,
        fieldTypes: { TaraID: 'Guid' },
        beforeSend: (e: any) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
          };
        },
      });
      const rows: any[] = await store.load({ filter: ['TaraID', '=', taraId], select: ['ID', 'Nume'] });
      const target = this.normalizeazaText(nume);
      return rows.find(j => this.normalizeazaText(j.Nume) === target) ?? null;
    },
    async onSearchAnaf() {
      const cuiRaw = this.newPartnerData.CUI;
      if (!cuiRaw) {
        notify("Te rog introdu un CUI valid", "warning", 2000);
        return;
      }

      const cui = Number(String(cuiRaw).replace(/\D/g, ""));
      if (!cui) {
        notify("Te rog introdu un CUI valid", "warning", 2000);
        return;
      }

      try {
        const anafResult = await AnafService.getCompanyDetails(cui);

        if (!anafResult) {
          notify("CUI-ul nu a fost găsit sau nu există date publice.", "warning", 3000);
          return;
        }

        const dg = anafResult.date_generale;
        const df = anafResult.adresa_domiciliu_fiscal;
        const ss = anafResult.adresa_sediu_social;
        const formaOrg = String(dg?.forma_organizare ?? "").toUpperCase().trim();
        const scpTVA = Boolean(anafResult?.inregistrare_scop_Tva?.scpTVA);

        let fiscal: string | null = null;

        if (formaOrg.includes("PERSOANA FIZICA")) {
          fiscal = "F";
        } else if (formaOrg.includes("PERSOANA JURIDICA")) {
          fiscal = scpTVA ? "P" : "N";
        }

        // setezi doar dacă ai determinat ceva clar
        if (fiscal) {
          this.newPartnerData.Fiscal = fiscal;
        }

        // La fel ca în legacy (PAR_ParteneriForm.cs): CUI cu prefix "RO" doar dacă firma e
        // înregistrată ca plătitor de TVA la data căutării, altfel fără prefix.
        this.newPartnerData.CUI = scpTVA ? `RO${dg.cui}` : String(dg.cui);
        this.newPartnerData.Nume = dg.denumire ?? this.newPartnerData.Nume;
        this.newPartnerData.Numar = dg.nrRegCom ?? this.newPartnerData.Numar;
        this.newPartnerData.Caen = dg.cod_CAEN ?? this.newPartnerData.Caen;
        this.newPartnerData.CAdresa = dg.adresa ?? this.newPartnerData.CAdresa;
        this.newPartnerData.CStrada = df?.ddenumire_Strada ?? this.newPartnerData.CStrada;
        this.newPartnerData.CNumarstrada = df?.dnumar_Strada ?? this.newPartnerData.CNumarstrada;
        this.newPartnerData.CLocalitate = df?.ddenumire_Localitate ?? this.newPartnerData.CLocalitate;
        this.newPartnerData.CCP = df?.dcod_Postal ?? dg.codPostal ?? this.newPartnerData.CCP;
        this.newPartnerData.Adresa = ss?.sdetalii_Adresa ?? this.newPartnerData.Adresa;
        this.newPartnerData.Localitate = ss?.sdenumire_Localitate ?? this.newPartnerData.Localitate;
        this.newPartnerData.Strada = ss?.sdenumire_Strada ?? this.newPartnerData.Strada;
        this.newPartnerData.Numarstrada = ss?.snumar_Strada ?? this.newPartnerData.Numarstrada;
        this.newPartnerData.CP = ss?.scod_Postal ?? this.newPartnerData.CP;
        this.newPartnerData.Tel = dg.telefon ?? this.newPartnerData.Tel;
        this.newPartnerData.Fax = dg.fax ?? this.newPartnerData.Fax;

        if (dg.iban) this.newPartnerData.Cont = dg.iban;

        this.newPartnerData.AplicaTVAlaIncasare = anafResult.inregistrare_RTVAI?.statusTvaIncasare ?? this.newPartnerData.AplicaTVAlaIncasare;
        this.newPartnerData.AplicaTvaDefalcat = anafResult.inregistrare_SplitTVA?.statusSplitTVA ?? this.newPartnerData.AplicaTvaDefalcat;
        if (anafResult.stare_inactiv?.statusInactivi) {
          this.newPartnerData.Activ = false;
          notify("Atenție: firma este marcată ca INACTIVĂ la ANAF!", "warning", 4000);
        }

        // Formularul nu are câmp vizibil de Județ, dar JudetID se trimite oricum la salvare —
        // se caută prin numele întors de ANAF (ex: "BIHOR") în nomenclatorul ERP_Judete,
        // normalizat (fără diacritice/case), ca să nu rămână null.
        if (!this.newPartnerData.TaraID) {
          this.newPartnerData.TaraID = "D31C3594-8D39-4355-9A13-FD699A1B7290"; // Romania
        }
        if (ss?.sdenumire_Judet) {
          const judet = await this.cautaJudetDupaNume(ss.sdenumire_Judet, this.newPartnerData.TaraID);
          if (judet) {
            this.newPartnerData.JudetID = judet.ID;
          } else {
            console.warn(`Județul „${ss.sdenumire_Judet}" (Sediu Social) nu a fost găsit în nomenclator.`);
          }
        }
        if (df?.ddenumire_Judet) {
          if (!this.newPartnerData.CTaraID) this.newPartnerData.CTaraID = this.newPartnerData.TaraID;
          const cJudet = await this.cautaJudetDupaNume(df.ddenumire_Judet, this.newPartnerData.CTaraID);
          if (cJudet) {
            this.newPartnerData.CJudetID = cJudet.ID;
          } else {
            console.warn(`Județul „${df.ddenumire_Judet}" (Domiciliu Fiscal) nu a fost găsit în nomenclator.`);
          }
        }

        const extras: string[] = [];
        if (dg.stare_inregistrare) extras.push(`Stare: ${dg.stare_inregistrare}`);
        if (typeof dg.statusRO_e_Factura === "boolean") extras.push(`RO e-Factura: ${dg.statusRO_e_Factura ? "DA" : "NU"}`);
        if (dg.organFiscalCompetent) extras.push(`Organ fiscal: ${dg.organFiscalCompetent}`);

        if (extras.length) {

          const prev = this.newPartnerData.Memo ? String(this.newPartnerData.Memo).trim() + "\n" : "";
          this.newPartnerData.Memo = prev + extras.join(" | ");
        }

        notify("Datele au fost preluate cu succes din ANAF!", "success", 2000);
      } catch (error: any) {
        console.error(error);
        notify("Eroare la interogarea ANAF (" + (error?.message || "Unknown") + ")", "error", 4000);
      }
    },
    onAddNewBank() {
      this.isBankModalVisible = true;
    },
    onBanciRowClick(e) {
      // 1. Close the dropdown
      this.isBanciGridBoxOpened = false;

      // 2. Update the value
      if (e.data) {
        this.sBanci = e.data.Id;
        // SAVE NAME INSTEAD OF ID
        this.newPartnerData.Banca = e.data.Nume;

        // Legacy/Other
        this.newBankData.Banca = e.data.Nume;
        this.newBankData.PartenerId = e.data.Id;
      } else {
        this.sBanci = null;
        this.newPartnerData.Banca = '';
        this.newBankData.PartenerId = null;
      }
    },

    displayCompanie(item) {
      return item ? (item.Nume || '(fără nume)') : '';
    },
    goToOpportunities() {
      this.$router.push({ name: 'GridOportunitati' });
    },

    onValueSelectedPartener(e) {
      this.isParteneriGridBoxOpened = false;

      if (e.selectedRowKeys.length > 0) {
        this.sPartener = e.selectedRowKeys[0];

      } else {
        this.sPartener = null;
      }
      this.formData.AccountID = this.sPartener;
    },

    onValueSelectedContact(e) {
      this.isContacteGridBoxOpened = false;

      if (e.selectedRowKeys.length > 0) {
        this.sContact = e.selectedRowKeys[0];
        const contactData = e.selectedRowsData[0];
        if (contactData && contactData.AccountID) {
          this.sPartener = contactData.AccountID;
          this.formData.AccountID = contactData.AccountID;
        }
      } else {
        this.sContact = null;
      }
      this.formData.ContactID = this.sContact;
    },
    onValueSelectedIndustrie(e) {
      this.isIndustrieGridBoxOpened = false;

      if (e.selectedRowKeys.length > 0) {
        this.sIndustrie = e.selectedRowKeys[0];

      } else {
        this.sIndustrie = null;
      }
      this.formData.IndustrieID = this.sIndustrie;
    },
    onValueSelectedCampanie(e) {
      this.isCampaniiGridBoxOpened = false;

      if (e.selectedRowKeys.length > 0) {
        this.sCampanie = e.selectedRowKeys[0];

      } else {
        this.sCampanie = null;
      }
      this.formData.CampanieID = this.sCampanie;
    },
    onDropDownValueChanged(e) {
      // e.value va fi null dacă se apasă butonul de clear (X)
      if (!e.value) {
        this.sValuta = null;
        this.formData.ValutaID = null;
        // Opțional: poți forța grid-ul să-și reseteze selecția aici dacă ai un ref către el
      }
    },
    onValueSelectedValuta(e) {
      this.isValutaGridBoxOpened = false;
      if (e.selectedRowKeys.length > 0) {
        this.sValuta = e.selectedRowKeys[0];
      } else {
        this.sValuta = null;
      }
      this.newPartnerData.ValutaID = this.sValuta;
    },
    onValueSelectedPartnerValuta(e) {
      this.isPartnerValutaGridBoxOpened = false;
      if (e.selectedRowKeys.length > 0) {
        this.sValuta = e.selectedRowKeys[0];
      } else {
        this.sValuta = null;
      }
      this.newPartnerData.ValutaID = this.sValuta;
    },
    toNullIfEmpty(val) {
      return val === '' || val === undefined || val === null ? null : val;
    },
    onValuteRowClick(e) {
      this.isValuteGridBoxOpened = false;

      if (e.data) {
        this.sValute = e.data.Id;
        if (this.isBankModalVisible) {
          this.newBankData.ValutaID = e.data.Id;
        } else if (this.isPartnerModalVisible) {
          this.newPartnerData.ValutaID = e.data.Id;
        }
      } else {
        this.sValute = null;
        if (this.isBankModalVisible) {
          this.newBankData.ValutaID = null;
        } else if (this.isPartnerModalVisible) {
          this.newPartnerData.ValutaID = null;
        }
      }
    },
    normalizeFormData(formData) {
      const cleaned = { ...formData };
      const dateFields = [
        'DataInchidereEstimat',
        'DataInchis',
        'Data',
        'DataCreat',
        'DataModificat'
      ];

      dateFields.forEach((field) => {
        const val = cleaned[field];
        cleaned[field] = this.toNullIfEmpty(val) !== null ? new Date(val) : null;
      });

      Object.keys(cleaned).forEach((key) => {
        cleaned[key] = this.toNullIfEmpty(cleaned[key]);
      });

      return cleaned;
    },
    onSaveAddContact() {

      const result = this.$refs.form.instance.validate();
      if (!result.isValid) {
        return;
      }

      const nume = this.contactData.Nume?.trim();

      const numeRegex = /^[A-Za-zĂÂÎȘȚăâîșț ]{2,}$/;

      if (!nume) {
        notify('Câmpul "Nume" este obligatoriu!', 'error', 1000);
        return;
      }

      if (!numeRegex.test(nume)) {
        notify(
          'Câmpul "Nume" trebuie să conțină doar litere și să aibă cel puțin 2 caractere.',
          'error',
          2000
        );
        return;
      }

      if (!this.contactData.AccountID) {
        notify('Eroare: Contactul trebuie să fie asociat unei companii!', 'error', 2000);
        return;
      }
      const cleanedFormData = { ...this.contactData };
      if (!cleanedFormData.Owner) {
        cleanedFormData.Owner = JwtServices.GetUsername();
      }
      const toNullIfEmpty = (val) => {
        return val === '' || val === undefined ? null : val;
      };
      if (cleanedFormData.DataNasterii) {
        cleanedFormData.DataNasterii = new Date(cleanedFormData.DataNasterii);
      }
      cleanedFormData.Activ = cleanedFormData.Activ ? true : null;
      cleanedFormData.ContactPrimar = cleanedFormData.ContactPrimar ? true : null;
      cleanedFormData.Imagine = toNullIfEmpty(cleanedFormData.Imagine);

      const fieldsToNull = [
        'DataNasterii', 'Activ', 'Imagine',
        'ContactPrimar'
      ];
      fieldsToNull.forEach((field) => {
        cleanedFormData[field] = toNullIfEmpty(cleanedFormData[field]);
      });


      CrmContacts.save(cleanedFormData)
        .then((response) => {
          this.isContactModalVisible = false;
          notify('Datele au fost salvate cu succes!', 'success', 1000);

          const newId = response?.data?.ID || response?.data?.Id || response?.data?.id;

          this.contactData = {
            ID: '',
            Nume: '',
            Prenume: '',
            DataNasterii: null,
            Titlu: '',
            AccountID: null,
            Email: '',
            TelMunca: '',
            TelMobil: '',
            Fax: '',
            TaraID: null,
            LocalitateID: null,
            Adresa: '',
            MetodaContact: '',
            Note: '',
            Activ: true,
            Owner: '',
            Imagine: null,
            ContactPrimar: true,

          };
          this.dsContacts.load();
        })
        .catch((error) => {
          notify('Eroare la salvare!', 'error', 1500);
        });
    },
    onSaveAdd() {

      if (!this.formData.Titlu) {
        notify('Completați câmpul obligatoriu "Denumire Oportunitate"!', 'error', 1000);
        return;
      }

      if (!this.formData.SursaID) {
        notify('Completați câmpul obligatoriu "Sursă Lead"!', 'error', 1000);
        return;
      }
      if (!this.formData.Data) {
        this.formData.Data = new Date();
      }
      const cleanedFormData = this.normalizeFormData(this.formData);
      const backendFields = [
        'Titlu', 'ContactID', 'AccountID', 'Sursa', 'IntervalCumparare',
        'BugetEstimat', 'Note', 'Cerere', 'Oferta', 'DataInchidereEstimat',
        'VenitEstimat', 'Probabilitate', 'StatusID', 'Owner', 'UserCreat',
        'DataCreat', 'UserModificat', 'DataModificat', 'VenitRealizat',
        'DataInchis', 'UltimulStatus', 'MotivInchidere', 'IndustrieID',
        'CampanieID', 'CostEstimat', 'CostEfectiv', 'ListaProduse', 'Cod',
        'Discount', 'ValutaID', 'Curs', 'SursaID', 'Data', 'ProiectID', 'ProbabilitateCastig'
      ];

      const payload = Object.fromEntries(
        Object.entries(cleanedFormData).filter(([key]) =>
          backendFields.includes(key)
        )
      );

      if (!cleanedFormData.Owner) {
        cleanedFormData.Owner = JwtServices.GetUsername();
      }
      payload.ContactID = this.toNullIfEmpty(this.sContact);
      payload.AccountID = this.toNullIfEmpty(this.sPartener);


      console.log('Payload being saved:', payload);
      CrmSales.save(payload)
        .then((response) => {
          this.isModalVisible = false;
          notify('Datele au fost salvate cu succes!', 'success', 1000);

          const newId = response?.data?.ID || response?.data?.Id || response?.data?.id;

          if (newId) {
            this.$router.push({ name: 'GridOportunitati', query: { opportunityId: newId } });
          } else {
            console.error("New Opportunity ID not found in response", response);
          }
          this.formData = {
            Titlu: '',
            ContactID: null,
            AccountID: null,
            Sursa: '',
            IntervalCumparare: '',
            BugetEstimat: null,
            Note: '',
            Cerere: '',
            Oferta: '',
            DataInchidereEstimat: null,
            VenitEstimat: null,
            Probabilitate: '0',
            StatusID: 'BE62B2A3-AEA9-4706-ADED-934622DBEFD9',
            Owner: '',
            UserCreat: '',
            DataCreat: null,
            UserModificat: '',
            DataModificat: null,
            VenitRealizat: null,
            DataInchis: null,
            UltimulStatus: '',
            MotivInchidere: '',
            IndustrieID: null,
            CampanieID: null,
            CostEstimat: null,
            CostEfectiv: null,
            ListaProduse: '',
            Cod: '',
            Discount: null,
            ValutaID: null,
            Curs: null,
            SursaID: null,
            Data: null,
            ProiectID: null,
            ProbabilitateCastig: null,
          };
          this.sContact = null;
          // this.createODataContext(); // Removed full reset
          if (this.$refs.dataGrid && this.$refs.dataGrid.instance) {
            this.$refs.dataGrid.instance.refresh();
          }
        })
        .catch((error) => {
          console.error(error);
          notify('Eroare la salvare!', 'error', 1500);
        });
    },
    onViewDetails(e) {
      const rowData = e?.row?.data;
      if (rowData) {
        this.showOpportunityDetails(rowData);
      }
    },
    onRowClick(e) {
      const rowData = e.data;
      const id = rowData?.ID || rowData?.Id || rowData?.id;

      if (id) {
        this.$router.push({ path: '/crm/grid-oportunitati', query: { opportunityId: id } });
      }
    },
    showOpportunityDetails(opportunity: any) {

      this.selectedOpportunity = {
        ...opportunity,
        Contact: opportunity.Contact ? `${opportunity.Contact.Nume ?? ''} ${opportunity.Contact.Prenume ?? ''}`.trim() : '-',
        Account: opportunity.Account?.Nume,
        Industrie: opportunity.Industrie?.Nume,
        Campanie: opportunity.Campanie?.Denumire,
        Valuta: opportunity.Valuta?.Simbol,
        Sursa: opportunity.Sursa?.Nume,
        Status: opportunity.Status?.Nume || opportunity.Status
      };
      this.isOpportunityDetailsVisible = true;
    },
    onAddClick() {
      const user = JwtServices.GetUsername();
      this.Username = user;
      this.formData.Owner = user;

      this.sContact = this.contactId;
      this.formData.ContactID = this.contactId;

      this.sPartener = this.accountId;
      this.formData.AccountID = this.accountId;

      this.formData.Data = new Date(); // Default to current date
      this.formData.StatusID = 'BE62B2A3-AEA9-4706-ADED-934622DBEFD9';
      this.formData.Probabilitate = 0;
      this.formData.ValutaID = '0A61647E-7391-4087-BC01-8EB9C2CEDEDD';

      this.isModalVisible = true;
    },
    onSaveNewBank() {
      if (!this.newBankData.Nume || this.newBankData.Nume.trim() === '') {
        notify('Completați câmpul obligatoriu "Nume"!', 'error', 1000);
        return;
      }

      console.log(this.newBankData);
      const body = this.newBankData;
      const savedBankData = { ...this.newBankData }; // Capture data before reset

      PAR_Parteneri.saveBank(body).then((response) => {
        this.isBankModalVisible = false;
        notify('Datele au fost salvate cu succes!', 'success', 1000);

        const newId = response?.data?.ID || response?.data?.Id || response?.data?.id || response?.data;

        // Refresh data source and set selection
        this.dsBanci.reload().then(() => {
          if (newId) {
            console.log("Setting new bank:", newId, savedBankData.Nume);
            this.sBanci = newId;
            this.newPartnerData.Banca = savedBankData.Nume;
          }
        });

        this.newBankData = {
          PartenerID: null,
          Cod: null,
          Nume: null,
          CodIBAN: null,
          CodBIC: null,
          Principala: null,
          CodSWIFT: null,
          ValutaID: null,
          Ordine: null,
          Activ: null,
          TextFC: null,
        };
      }).catch((error) => {
        console.error(error);
        notify('Datele există deja sau a apărut o eroare!', 'error', 2000);
      });
    },
    onRefreshClick() {
      this.createODataContext();
      notify('Datele au fost actualizate cu succes!', 'success', 1000);
    },
    SaveEdit() {
      const savePromise = this.$refs.dataGrid?.instance?.saveEditData();
      savePromise
        .then(() => {
          notify('Datele au fost salvate cu succes!', 'success', 1000);
        })
        .catch((error) => {
          notify('Eroare la salvarea datelor!', 'error', 1000);
        });
    },
    onCancel() {
      this.isModalVisible = false;
      this.$refs.dataGrid?.instance?.cancelEditData();
    },
    onCancelContact() {
      this.isContactModalVisible = false;
      this.$refs.dataGrid?.instance?.cancelEditData();
    },
    onRowRemoving(e) {
      if (e.data.Owner !== JwtServices.GetUsername()) {
        notify('Nu aveți permisiunea de a șterge această oportunitate!', 'error', 2000);
        e.cancel = true;
        return;
      }
      notify('Datele au fost șterse cu succes!', 'success', 1000);
    },
    onExporting(e: any) {
      if (e.format === 'pdf') {
        const doc = new jsPDF();
        exportDataGridPdf({
          jsPDFDocument: doc,
          component: e.component,
          indent: 5,
        }).then(() => {
          doc.save('CrmOportunitati.pdf');
        });
      } else if (e.format === 'xlsx') {

        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('oportunitati');

        exportDataGridExcel({
          component: e.component,
          worksheet,
          autoFilterEnabled: true,
        }).then(() => {
          workbook.xlsx.writeBuffer().then((buffer: any) => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'CrmContacts.xlsx');
          });
        });
        e.cancel = true;
      }
    },
    onPartenerRowClick(e) {

      if (e.data && e.data.ID) {
        const p = e.data;


        this.sPartener = p.ID;
        this.newPartnerData.AccountID = p.ID;
        this.newPartnerData.Adresa = p.Adresa || '';
        this.newPartnerData.TaraID = p.TaraID;
        //this.formData.LocalitateID = p.LocalitateID || '';

        setTimeout(() => {
          this.isParteneriGridBoxOpened = false;
        }, 150);
      }
    },
    onSaveNewPartner() {
      if (!this.newPartnerData.Nume || this.newPartnerData.Nume.trim() === '') {
        notify('Completați câmpul obligatoriu "Nume"!', 'error', 1000);
        return;
      }

      if (!this.newPartnerData.Fiscal) {
        notify('Completați câmpul obligatoriu "Tip Fiscal"!', 'error', 1000);
        return;
      }

      console.log(this.newPartnerData);
      const body = this.newPartnerData;
      const savedPartnerData = { ...this.newPartnerData }; // Capture data before reset

      PAR_Parteneri.save(body).then((response) => {
        this.isPartnerModalVisible = false;
        notify('Datele au fost salvate cu succes!', 'success', 1000);

        const newId = response.data?.ID || response.data?.Id;

        if (newId) {
          this.formData.AccountID = newId;
          this.sPartener = newId;

          // Mapare adresa
          if (response.data.Adresa) this.formData.Adresa = response.data.Adresa;
          if (response.data.TaraID) this.formData.TaraID = response.data.TaraID;
          if (response.data.JudetID) this.formData.JudetID = response.data.JudetID;

          console.log("ID setat pentru contact:", this.formData.AccountID);
        }

        // 3. DOAR RELOAD-UL IL LASI IN TIMEOUT daca e necesar pentru interfata
        this.dsParteneri.reload();

      }).catch((error) => {
        console.error("Eroare la salvare partener:", error);
        notify('Eroare la salvare partener!', 'error', 1500);
      });
    },
    onAddNewPartener() {
      this.newPartnerData.Owner = JwtServices.GetUsername();
      this.newPartnerData.TaraID = 'D31C3594-8D39-4355-9A13-FD699A1B7290'; // Default Country: Romania
      this.isPartnerModalVisible = true;
      this.newPartnerData.ValutaID = '0A61647E-7391-4087-BC01-8EB9C2CEDEDD';
    },
    setDeleteConfirmationMessage() {
      const dataGrid = this.$refs.dataGrid?.instance;
      dataGrid.option('editing', {
        allowDeleting: true,
        mode: 'popup',
        texts: {
          confirmDeleteMessage: this.deleteConfirmationMessage,
          confirmDeleteTitle: "Confirmare Ștergere",
        }
      });
    },
    formatDate(dateStr: string, includeTime = false) {
      if (!dateStr) return '-';
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return '-';

      const options: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      };

      if (includeTime) {
        options.hour = '2-digit';
        options.minute = '2-digit';
      }

      return d.toLocaleDateString('ro-RO', options);
    },
    formatCurrency(value: number, currency: string) {
      if (value === null || value === undefined) return '-';
      return new Intl.NumberFormat('ro-RO', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value) + ' ' + (currency || 'RON');
    },
    onValutaValueChanged(e) {
      this.formData.ValutaID = e.value;
    },
    getStatusClass(status: string) {
      if (!status) return 'default';
      const s = String(status).toLowerCase();
      if (s.includes('deschis') || s.includes('open')) return 'open';
      if (s.includes('castig') || s.includes('won') || s.includes('succes')) return 'won';
      if (s.includes('pierd') || s.includes('lost') || s.includes('esec')) return 'lost';
      return 'default';
    },
    onValueSelectedProiect(e) {
      this.isProiecteGridBoxOpened = false;

      if (e.selectedRowKeys.length > 0) {
        this.sProiect = e.selectedRowKeys[0];

      } else {
        this.sProiect = null;
      }
      this.formData.ProiectID = this.sProiect;
    },
    isOwner(owner) {
      return owner === JwtServices.GetUsername();
    },
  },

  mounted() {

    this.intervalList = [
      { name: 'Imediat' },
      { name: 'Luna aceasta' },
      { name: 'Anul acesta' },
      { name: 'Trimestrul acesta' },
      { name: 'Trimestrul următor' },
      { name: 'Necunoscut' },
    ]
    this.createODataContext();
    this.setDeleteConfirmationMessage();
    loadMessages({
      "ro": {
        "Yes": "Da",
        "No": "Nu",
      }
    });

    locale('ro');
  },
});
</script>
<style scoped lang="scss">
.details-scroll-view {
  background-color: #f8f9fc;
}

.details-container {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Header Context */
.popup-header--details {
  background: linear-gradient(90deg, #ff2c21, #ff6a4a);
}

/* Stats Row */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.stat-card {
  background: white;
  padding: 16px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  }
}

.stat-icon {
  font-size: 24px;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #f0f4ff;
  color: #3f51b5;
}

.stat-card--revenue .stat-icon {
  background: #e8f5e9;
  color: #2e7d32;
}

.stat-card--revenue .stat-value {
  color: #2e7d32;
}

.stat-card--probability .stat-icon {
  background: #fff3e0;
  color: #ef6c00;
}

.stat-content {
  flex: 1;
}

.stat-label {
  font-size: 12px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  font-weight: 600;
}

.stat-value {
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
  margin-top: 2px;
}

.stat-progress {
  height: 4px;
  background: #f1f5f9;
  border-radius: 2px;
  margin-top: 8px;
  overflow: hidden;
}

.stat-progress-bar {
  height: 100%;
  background: #ef6c00;
  border-radius: 2px;
  transition: width 1s ease-out;
}

/* Info Sections */
.info-sections-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.info-column {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.info-section-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.section-header {
  padding: 14px 16px;
  background: #fcfcfd;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;
  color: #334155;
  font-size: 14px;
}

.section-icon {
  color: #64748b;
  font-size: 18px;
}

.info-list {
  padding: 8px 0;
}

.info-item {
  padding: 10px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;

  label {
    font-size: 11px;
    color: #94a3b8;
    text-transform: uppercase;
    font-weight: 600;
  }

  .value {
    font-size: 14px;
    color: #334155;
    font-weight: 500;

    &.multiline {
      line-height: 1.5;
      font-style: italic;
      color: #475569;
    }

    &.highlight {
      color: #2563eb;
    }

    &.success {
      color: #059669;
    }
  }
}

/* Status Chips */
.status-chip {
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);

  &--open {
    background: #e0f2fe;
    color: #0369a1;
    border-color: #bae6fd;
  }

  &--won {
    background: #dcfce7;
    color: #15803d;
    border-color: #bbf7d0;
  }

  &--lost {
    background: #fee2e2;
    color: #b91c1c;
    border-color: #fecaca;
  }
}

/* Metadata */
.system-meta-card {
  background: #f1f5f9;
  border-radius: 10px;
  padding: 12px 20px;
}

.meta-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #64748b;
}

.meta-icon {
  font-size: 14px;
}

.meta-separator {
  width: 1px;
  height: 14px;
  background: #cbd5e1;
}

/* Base popup styles restored */
.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 18px;
  background: linear-gradient(90deg, #ff2c21, #ff6a4a);
  color: #fff;
}

.popup-header-main {
  display: flex;
  align-items: center;
  gap: 10px;
}

.popup-header-icon {
  font-size: 20px;
}

.popup-header-texts {
  display: flex;
  flex-direction: column;
}

.popup-header-title {
  font-size: 15px;
  font-weight: 700;
}

.popup-header-subtitle {
  font-size: 12px;
  opacity: 0.85;
}

.popup-header-meta {
  display: flex;
  align-items: center;
}

.popup-body-modern {
  padding: 14px 18px 56px 18px;

}

.popup-body-simple {
  background: white;
  padding: 20px;
}

.form-content-modern {
  margin-top: 10px;
}

.form-content {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 60px;
}

.form-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 2px;
}

.footer-modern {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.02);
}

.footer-fixed {
  position: sticky;
  bottom: 0;
  padding: 10px 16px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  z-index: 10;
}

.footer-right .dx-button {
  margin-left: 8px;
}

.footer-left .dx-button {
  margin-left: 8px;
}


// ============================================
// POPUP STYLING - SIMPLE APP STYLE (from GridTabOportunitati)
// ============================================

.popup-body-simple {
  background: white;
  padding: 20px;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.form-content {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 10px;
}

// Form Section Simple
:deep(.form-section-simple) {
  .dx-form-group-caption {
    background: #f8f9fa;
    color: #333;
    font-size: 14px;
    font-weight: 600;
    padding: 10px 15px;
    margin: 15px 0 10px 0;
    border-left: 3px solid #ff2c21;
    border-radius: 0;
  }

  .dx-form-group-content {
    background: white;
    padding: 15px 0;
    margin-bottom: 10px;
  }
}

.footer-fixed {
  position: sticky;
  bottom: 0;
  padding: 10px 16px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  z-index: 10;
}

.footer-modern {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  align-items: center;
  padding: 8px 18px;
  border-top: 1px solid #e2e2ed;
  background-color: #fff;
}

// Form Fields
:deep(.dx-field-item) {
  margin-bottom: 15px;

  .dx-field-item-label-text {
    font-weight: 500;
    color: #333;
    font-size: 13px;
    margin-bottom: 5px;
  }

  .dx-texteditor,
  .dx-dropdownbox,
  .dx-selectbox {
    border-radius: 4px;
    border-color: #ddd;

    &:hover {
      border-color: #bbb;
    }

    &.dx-state-focused {
      border-color: #ff2c21;
    }
  }

  .dx-texteditor-input {
    padding: 8px 10px;
    font-size: 13px;
  }
}

:deep(.dx-scrollview-content) {
  padding: 0;
}
</style>